// Pandora Box — samlet app-logik (data, Shopify, 3D-motor, admin, presets)
// Ingen afhængigheder af pandora-box-assets.js længere — alle 3D-modeller
// hentes nu live fra admin-appen (.glb-filer via GLTFLoader), ikke den
// gamle indbyggede geometri.

const DB = {
  // NB: price her er kun "Kube"-skallens egen pris. Bekræftet fra Shopify
  // Admin at Kube/Kube til låge/Kube til skuffer alle koster 549 kr som
  // variant — tillægget for skuffer/låge kommer fra de separate tilkøbs-
  // produkter (Skuffesæt til kube / Låge til kube), lagt til dynamisk i
  // updateTotal() og buildShopifyCartItems(). "Kube med hylde" ER derimod
  // et helt separat produkt med sin egen pris (649 kr, ikke tilkøb).
  types: [
    {id:1, name:'Åben kube',        code:'AK', w:36, h:36, d:34.5, price:549,  feature:'open'   },
    {id:2, name:'Kube med hylde',   code:'KH', w:36, h:36, d:34.5, price:649,  feature:'shelf'  },
    {id:3, name:'Kube med skuffer', code:'KS', w:36, h:36, d:34.5, price:549,  feature:'drawers'},
    {id:4, name:'Kube med låge',    code:'KL', w:36, h:36, d:34.5, price:549,  feature:'door'   },
  ],
  // Ingen indbyggede farver længere — ALLE farver kommer nu udelukkende
  // fra admin-appen (se loadRemoteConfig() nedenfor). FALLBACK_COLOR
  // (defineret lige efter DB) bruges kun som nødløsning, hvis admin-appen
  // skulle være helt utilgængelig ved allerførste indlæsning.
  colors: [],
  textures: [],
  models:   [],
  stack:    [],
  nextId:   100,
  nextSID:  1,
};

// Bruges KUN hvis DB.colors er helt tom, OG admin-appens farve-endpoint
// ikke kunne nås ved opstart (fx netværksfejl) — forhindrer at
// konfiguratoren går i sort, i stedet for en fejlende builder for hele
// scenen. Vises ALDRIG som et rigtigt valg, hvis mindst én admin-farve
// er hentet korrekt.
const FALLBACK_COLOR = { id: -1, name: 'Standard', hex: '#cccccc' };

// selColorId sættes rigtigt (til den første admin-farve) lige efter
// loadRemoteConfig() er kørt i DOMContentLoaded-handleren nedenfor —
// null her er kun en midlertidig placeholder inden det.
const S = { mode:'add', selId:null, selTypeId:1, selColorId:null, sokkelOn:false, multiSelIds: new Set() };

// URL til admin-appens OFFENTLIGE farve-endpoint (ingen login krævet at
// læse den) — nye farver, oprettet direkte fra Shopify-varianter i admin-
// appen, lægges automatisk oven i DB.colors herfra, live, uden en
// redeploy af selve konfiguratoren. Skift kun denne, hvis admin-appens
// adresse nogensinde ændrer sig (fx til et eget domæne).
const ADMIN_APP_PUBLIC_COLORS_URL = 'https://pandora-box-admin-app.vercel.app/api/public-colors';

// Shopify-farvetekst → intern farve-id (fx "EGGER - w1000 st9 Hvid" →
// 1786465861434662) og Shopify produkt-handle → kind (kube/door/osv.) —
// begge hentet live fra admin-appen sammen med farverne.
let REMOTE_COLOR_MAPPING = {};

// Admin-oprettede opstillinger, hentet live fra admin-appen sammen med
// farverne — erstatter de 4 tidligere hardcodede demo-opstillinger.
let REMOTE_PRESETS = [];

// Admin-uploadede ERSTATNINGS-modeller for de 5 indbyggede dele (kube-
// skal, hylde i Kube med hylde, hylde i skuffe-kube, skuffe, låge) —
// mangler en del, bruges den oprindelige indbyggede model uændret.
let REMOTE_MODEL_URLS = {};

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str == null ? '' : String(str);
  return div.innerHTML;
}

// Udfyldes dynamisk ud fra jeres produkt-tilknytning i admin-appen (se
// loadRemoteConfig nedenfor) — ikke længere hardcodet/indsat manuelt.
let SHOPIFY_PRODUCT_HANDLES = {
  kube: null, kubeMedHylde: null, skuffesaet: null, laage: null, sokkel: null, vaegbeslag: null,
};

// Hvilke farver findes RENT FAKTISK som en variant på Skuffesæt til
// kube/Låge til kube — beregnes én gang ved opstart (computeAccessoryColorCoverage),
// og bruges til at SKJULE farver i skuffe-/låge-vælgeren, som kunden godt
// kan se på selve kuben, men som ikke findes på tilkøbsproduktet. Uden
// dette kunne en kunde vælge en farve til lågen, konfiguratoren viser
// helt normalt i 3D, men som stille forsvinder fra kurven ved "Læg i
// kurv", fordi der ingen rigtig variant er at lægge i kurven.
let DOOR_COVERED_COLOR_IDS = new Set();
let DRAWER_COVERED_COLOR_IDS = new Set();

async function computeAccessoryColorCoverage() {
  async function coverage(handle) {
    if (!handle) return new Set();
    try {
      const product = await fetchShopifyProduct(handle);
      const ids = new Set();
      product.variants.forEach(v => {
        const id = REMOTE_COLOR_MAPPING[v.option1];
        if (id != null) ids.add(id);
      });
      return ids;
    } catch (err) {
      return new Set(); // kunne ikke afgøres — tolkes som "ingen begrænsning" nedenfor
    }
  }
  [DOOR_COVERED_COLOR_IDS, DRAWER_COVERED_COLOR_IDS] = await Promise.all([
    coverage(SHOPIFY_PRODUCT_HANDLES.laage),
    coverage(SHOPIFY_PRODUCT_HANDLES.skuffesaet),
  ]);
}

// Indlæser GLTFLoader dynamisk, KUN hvis der rent faktisk findes en
// admin-oprettet bokstype at vise (langt de fleste butikker vil aldrig
// ramme dette) — ingen grund til at alle kunder skal hente et ekstra
// 3D-bibliotek, de sandsynligvis ikke får brug for.
function ensureGLTFLoaderAvailable() {
  return new Promise((resolve) => {
    if (THREE.GLTFLoader && THREE.DRACOLoader) { resolve(); return; }
    const urls = [
      'https://unpkg.com/three@0.128.0/examples/js/loaders/GLTFLoader.js',
      // DRACOLoader — nogle admin-uploadede .glb-filer (typisk større
      // modeller, komprimeret for at kunne uploades) bruger Draco-
      // komprimeret geometri, som GLTFLoader ikke selv kan afkode uden
      // denne. Uden den fejler indlæsningen af DEN slags filer.
      'https://unpkg.com/three@0.128.0/examples/js/loaders/DRACOLoader.js',
    ];
    let i = 0;
    const loadNext = () => {
      if (i >= urls.length) { resolve(); return; }
      const s = document.createElement('script');
      s.src = urls[i++];
      s.onload = loadNext;
      s.onerror = () => { console.warn('Kunne ikke indlæse 3D-loader — admin-modeller falder tilbage til den indbyggede/en simpel kasse.'); resolve(); };
      document.head.appendChild(s);
    };
    loadNext();
  });
}

// Delt DRACOLoader-instans + en fælles måde at oprette en GLTFLoader med
// den allerede tilkoblet — genbruges alle steder i filen, i stedet for
// at hver loader selv skal huske at sætte den op.
let _dracoLoader = null;
// Kloner en cached admin-model ind i scenen. Bemærk: kloning har været
// undersøgt som mulig årsag til, at sokkel_2/3 ikke viser sig korrekt
// (i modsætning til sokkel_1/4, som virker fint) — men et forsøg på en
// "mere robust" klone-metode (SkeletonUtils.clone) viste sig faktisk at
// ØDELÆGGE sokkel_1, så det blev rullet tilbage. Simpel .clone(true) er
// den bekræftet-virkende metode.
function cloneModel(template) {
  return template.clone(true);
}

function newGltfLoader() {
  const loader = new THREE.GLTFLoader();
  if (THREE.DRACOLoader) {
    if (!_dracoLoader) {
      _dracoLoader = new THREE.DRACOLoader();
      _dracoLoader.setDecoderPath('https://unpkg.com/three@0.128.0/examples/js/libs/draco/');
    }
    loader.setDRACOLoader(_dracoLoader);
  }
  return loader;
}

// Henter og cacher selve .glb-filerne for alle admin-oprettede bokstyper
// ÉN gang ved opstart — så buildBox()/buildCustomBox() kan forblive
// synkront (kloner bare fra cachen), akkurat som resten af 3D-motoren.
async function preloadCustomTypeModels() {
  const customTypes = DB.types.filter(t => t.feature === 'custom' && t.modelUrl);
  if (!customTypes.length) return;
  await ensureGLTFLoaderAvailable();
  if (!THREE.GLTFLoader) return; // indlæsning fejlede — fortsæt med fallback-kassen

  await Promise.all(customTypes.map(t => new Promise((resolve) => {
    const loader = newGltfLoader();
    loader.load(t.modelUrl, (gltf) => {
      CUSTOM_MODEL_CACHE[t.id] = gltf.scene;
      resolve();
    }, undefined, (err) => {
      console.warn(`Kunne ikke indlæse 3D-model for bokstypen "${t.name}":`, err.message);
      resolve();
    });
  })));
}

// Samme princip som preloadCustomTypeModels(), men for admin-uploadede
// ERSTATNINGER af de 5 indbyggede dele (kube/hylde/hylde_shelf/skuffe/
// laage). Mangler en del sin URL (eller fejler indlæsningen), forbliver
// BUILTIN_MODEL_CACHE[key] tom, og buildBox() falder automatisk tilbage
// til den oprindelige, hardcodede model for netop den del — se buildBox().
// Admin-appens gemte X/Y/Z-justering (mm) pr. del — {kube|hylde_shelf|
// skuffe|hylde|laage: {x,y,z}} i WORLD UNITS (allerede omregnet), klar
// til at lægges direkte til en position. Udfyldes af preloadBuiltinModels().
const BUILTIN_MODEL_OFFSETS = {};

async function preloadBuiltinModels() {
  // modelUrls[key] kan enten være en ren URL-streng (ældre data, ingen
  // justering) eller { url, offsetX, offsetY, offsetZ } (mm) — begge
  // formater understøttes.
  const entries = Object.entries(REMOTE_MODEL_URLS).filter(([, v]) => v && (typeof v === 'string' ? v : v.url));
  if (!entries.length) return;
  console.info('[sokkel] RÅ data modtaget fra admin-appen for alle dele:', JSON.parse(JSON.stringify(REMOTE_MODEL_URLS)));
  await ensureGLTFLoaderAvailable();
  if (!THREE.GLTFLoader) return;

  await Promise.all(entries.map(([key, v]) => new Promise((resolve) => {
    const url = typeof v === 'string' ? v : v.url;
    const offsetMm = typeof v === 'object' ? v : {};
    // mm → meter → world units (samme MODEL_UNIT_SCALE-omregning som
    // resten af filen bruger for selve modellerne).
    BUILTIN_MODEL_OFFSETS[key] = {
      x: ((offsetMm.offsetX || 0) / 1000) * MODEL_UNIT_SCALE,
      y: ((offsetMm.offsetY || 0) / 1000) * MODEL_UNIT_SCALE,
      z: ((offsetMm.offsetZ || 0) / 1000) * MODEL_UNIT_SCALE,
    };
    const loader = newGltfLoader();
    loader.load(url, (gltf) => {
      BUILTIN_MODEL_CACHE[key] = gltf.scene;
      resolve();
    }, undefined, (err) => {
      console.warn(`Kunne ikke indlæse admin-erstatningsmodel for "${key}" — bruger den indbyggede i stedet:`, err.message);
      resolve();
    });
  })));
}

async function loadRemoteConfig() {
  try {
    const res = await fetch(ADMIN_APP_PUBLIC_COLORS_URL, { cache: 'no-store' });
    if (!res.ok) return;
    const data = await res.json();

    const extra = Array.isArray(data.colors) ? data.colors : [];
    extra.forEach(c => {
      if (c && c.id != null && !DB.colors.some(existing => existing.id === c.id)) {
        DB.colors.push(c);
      }
    });

    REMOTE_COLOR_MAPPING = data.colorMapping || {};
    REMOTE_PRESETS = Array.isArray(data.presets) ? data.presets : [];

    // Admin-oprettede bokstyper ("3D-modeller"-fanen) — lægges OVEN I de 4
    // indbyggede typer, ligesom farverne. "feature: 'custom'" fortæller
    // buildBox() at bruge buildCustomBox() i stedet for den indbyggede
    // skal/skuffe/låge-logik.
    REMOTE_MODEL_URLS = data.modelUrls || {};

    const customTypes = Array.isArray(data.customTypes) ? data.customTypes : [];
    customTypes.forEach(ct => {
      if (ct && ct.id != null && !DB.types.some(existing => existing.id === ct.id)) {
        DB.types.push({
          id: ct.id,
          name: ct.name,
          code: `C${ct.id}`,
          w: ct.w, h: ct.h, d: ct.d,
          price: ct.price || 0,
          feature: 'custom',
          modelUrl: ct.modelUrl,
          productHandle: ct.productHandle,
        });
      }
    });

    console.info(`Hentet fra admin-appen: ${DB.colors.length} farver, ${REMOTE_PRESETS.length} opstilling(er), ${customTypes.length} admin-bokstype(r).`);

    // Vend "handle → kind" om til "kind → handle" (det er sådan resten af
    // koden slår produkter op). Admin-appen bruger internt "drawer"/"door"
    // som kind-navne, mens SHOPIFY_PRODUCT_HANDLES (arvet fra den gamle,
    // manuelt indsatte kode) bruger "skuffesaet"/"laage" — de to skal
    // oversættes eksplicit, ellers springes koblingen for de to
    // tilkøbsprodukter (Skuffesæt til kube, Låge til kube) stille over.
    const KIND_TO_HANDLE_KEY = {
      kube: 'kube',
      kubeMedHylde: 'kubeMedHylde',
      drawer: 'skuffesaet',
      door: 'laage',
      sokkel: 'sokkel',
      vaegbeslag: 'vaegbeslag',
    };

    // Er et kind ved et uheld tilknyttet mere end ét produkt i
    // admin-appen, bruges det FØRSTE fundne, og resten logges som en
    // advarsel i stedet for at fejle stille eller crashe.
    const seen = {};
    Object.entries(data.productKindMapping || {}).forEach(([handle, kind]) => {
      const handleKey = KIND_TO_HANDLE_KEY[kind];
      if (!handleKey) return;
      if (seen[handleKey]) {
        console.warn(`Flere produkter tilknyttet "${kind}" — bruger "${seen[handleKey]}", ignorerer "${handle}"`);
        return;
      }
      SHOPIFY_PRODUCT_HANDLES[handleKey] = handle;
      seen[handleKey] = handle;
    });
  } catch (err) {
    console.warn('Kunne ikke hente farver/tilknytninger fra admin-appen — fortsætter med de indbyggede:', err.message);
  }
}
const SCL = 0.008;
const THICK = 0.00464;
const WALL_Z = -0.4352;          // wall plane z
const BASEBOARD_H = 0.01440;    // height of baseboard in world units (~1.8cm)

// Højden en gulv-stående boks' BUND skal sidde ved. Normalt BASEBOARD_H
// (en fast antagelse) — MEN er sokkel slået til, og en sokkel-model
// faktisk er indlæst, bruges soklens EGEN, målte højde i stedet, så
// kuben rent faktisk står OVENPÅ soklens plade, i stedet for enten at
// svæve over den eller synke ned i den. Alle 4 sokkel-størrelser
// forventes at have samme højde (kun bredden varierer) — bruger bare den
// første, der findes indlæst.
function floorRestY() {
  if (S.sokkelOn) {
    const anySokkelKey = Object.keys(BUILTIN_MODEL_CACHE).find(k => k.startsWith('sokkel_'));
    if (anySokkelKey) {
      const b = new THREE.Box3().setFromObject(BUILTIN_MODEL_CACHE[anySokkelKey]);
      return (b.max.y - b.min.y) * MODEL_UNIT_SCALE;
    }
  }
  return BASEBOARD_H;
}
const SNAP_DIST = 0.05;     // snap threshold in world units

const RS = { wallHex:'#C8C4BE', floorId:'wood_oak', showDims:false };

const WALL_PRESETS = [
  {name:'Hvid',     hex:'#F2F0ED'},
  {name:'Råhvid',   hex:'#E8E4DC'},
  {name:'Lys grå',  hex:'#C8C4BE'},
  {name:'Varm grå', hex:'#A89E92'},
  {name:'Støvet blå',hex:'#7A8E99'},
  {name:'Mosgrøn',  hex:'#6B7A5E'},
  {name:'Mørkegrøn',hex:'#3A4D3E'},
  {name:'Dyb marine',hex:'#2A3548'},
  {name:'Sort',     hex:'#2A2825'},
  {name:'Terracotta',hex:'#B05A40'},
];

const FLOOR_OPTIONS = [
  {id:'concrete',    label:'Beton grå',   color:'#CECCCA', pattern:null},
  {id:'wood_oak', label:'Eg træ', color:'#C4A87A', pattern:'image', tex:'data:image/jpeg;base64,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'},
  {id:'beton_beige', label:'Beton beige',  color:'#D4B896', pattern:'image', tex: 'data:image/jpeg;base64,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'}
];


// Pandora Box — SHOPIFY-INTEGRATION
// SKU-opslag, live priser, kurv-opbygning. Afhænger af data.js (DB, S).

// ═══════════════════════════════════════════
//  SHOPIFY CART INTEGRATION
// ═══════════════════════════════════════════
// STRUKTUR: "Kube" er ét produkt (Farve × Style: Kube/til låge/til
// skuffer), alle samme pris — stylen forbereder bare skallen. Skuffesæt
// og Låge er SELVSTÆNDIGE tilkøbsprodukter, ikke Kube-varianter, så en
// "Kube med skuffer" bliver 2 kurv-linjer. "Kube med hylde" er sit eget
// produkt. Farver er nu udelukkende admin-app-farver (se DB.colors).
//
// SKU-OPSLAG: Vi slår varianter op via Shopifys /products/{handle}.js
// (offentligt, kræver ikke token). Produkt-handles og farve-koblingen
// hentes live fra admin-appen (se loadRemoteConfig og
// REMOTE_COLOR_MAPPING/SHOPIFY_PRODUCT_HANDLES ovenfor) — ingen manuel
// kode-generering eller indsætning nødvendig mere.

// Genkender Kube-stylen ('AK'/'KL'/'KS') ud fra variantens egen style-
// tekst (fx "Kube til låge") — samme logik som admin-appen brugte til at
// generere den tidligere statiske kode, nu kørt live i browseren i stedet.
function detectKubeStyle(optionText) {
  const t = (optionText || '').toLowerCase();
  if (t.includes('låge')) return 'KL';
  if (t.includes('skuffe')) return 'KS';
  return 'AK';
}

// Genkender Sokkel-størrelsen (1-4) ud fra variantens egen tekst (fx "2
// kuber").
function detectSokkelSize(text) {
  const m = (text || '').match(/(\d+)/);
  return m ? Number(m[1]) : null;
}

// Fallback-priser — bruges KUN hvis et live variant-opslag mod Shopify
// fejler (fx midlertidig netværksfejl, eller produktet endnu ikke
// tilknyttet i admin-appen).
const ACCESSORY_PRICES = {
  drawer: null,
  door: null,
  vaegbeslag: null,
  sokkel: { 1: 199, 2: 289, 3: 399, 4: 479 },
};

// Henter og cacher produkt-data fra Shopify's offentlige, same-origin
// endpoint. Kræver INGEN nøgle/token — virker når værktøjet kører inde i
// selve Shopify-temaet (se SHOPIFY_SAME_ORIGIN nedenfor).
const _shopifyProductCache = {};
async function fetchShopifyProduct(handle) {
  if (!handle) throw new Error('Mangler produkt-handle — udfyld SHOPIFY_PRODUCT_HANDLES');
  if (_shopifyProductCache[handle]) return _shopifyProductCache[handle];
  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) throw new Error(`Kunne ikke hente produkt "${handle}" (${res.status})`);
  const data = await res.json();
  _shopifyProductCache[handle] = data;
  return data;
}

// Finder EN variant i et hentet produkt, der matcher en betingelse — kernen
// i det nye opslag: i stedet for at slå op via en manuelt indsat SKU, går
// vi selve variant-listen igennem og matcher på farve (via
// REMOTE_COLOR_MAPPING) og evt. style (via detectKubeStyle). Returnerer
// null (og logger en advarsel) hvis handle mangler eller intet matcher.
async function findVariant(handle, predicate, label) {
  if (!handle) { console.warn(`Intet produkt tilknyttet for: ${label} — se afsnit 2 i admin-appen`); return null; }
  try {
    const product = await fetchShopifyProduct(handle);
    const variant = product.variants.find(predicate);
    if (!variant) console.warn(`Ingen matchende variant fundet for: ${label}`);
    return variant || null;
  } catch (err) {
    console.warn('Kunne ikke hente produkt:', handle, err.message);
    return null;
  }
}

// Kube / Kube med hylde — matcher på farve, og for almindelige kuber
// (ikke KH) også på style (AK/KL/KS) via variantens EGEN style-tekst.
async function getKubeVariant(bt, colorId) {
  // Admin-oprettet bokstype (uploadet .glb) — har sit EGET, dedikerede
  // Shopify-produkt (sat i admin-appens "3D-modeller"-fane), matcher kun
  // på farve, ligesom Kube med hylde.
  if (bt.feature === 'custom') {
    return findVariant(bt.productHandle, v => REMOTE_COLOR_MAPPING[v.option1] === colorId, `${bt.code}_${colorId}`);
  }
  const isKH = bt.code === 'KH';
  const handle = isKH ? SHOPIFY_PRODUCT_HANDLES.kubeMedHylde : SHOPIFY_PRODUCT_HANDLES.kube;
  return findVariant(handle, v =>
    REMOTE_COLOR_MAPPING[v.option1] === colorId && (isKH || detectKubeStyle(v.option2) === bt.code),
    `${bt.code}_${colorId}`);
}

// Skuffesæt/Låge — selvstændige tilkøbsprodukter, matcher kun på farve.
async function getAccessoryVariant(kind, colorId) {
  const handle = kind === 'drawer' ? SHOPIFY_PRODUCT_HANDLES.skuffesaet : SHOPIFY_PRODUCT_HANDLES.laage;
  return findVariant(handle, v => REMOTE_COLOR_MAPPING[v.option1] === colorId, `${kind}_${colorId}`);
}

// Vægbeslag — ingen farve-varianter, bare det ene produkts eneste variant.
async function getVaegbeslagVariant() {
  return findVariant(SHOPIFY_PRODUCT_HANDLES.vaegbeslag, () => true, 'vaegbeslag');
}

// Sokkel — matcher på antal kuber (udledt af variantens egen tekst, fx
// "2 kuber"), dækker en HEL RÆKKE ad gangen.
async function getSokkelVariant(pieceSize) {
  return findVariant(SHOPIFY_PRODUCT_HANDLES.sokkel, v => detectSokkelSize(v.option1 || v.title) === pieceSize, `sokkel_${pieceSize}kube`);
}

// ═══════════════════════════════════════════
//  LIVE PRISER — fremtidssikret prisvisning
// ═══════════════════════════════════════════
// Priser hentes altid direkte fra den matchede variant (samme opslag som
// "Læg i kurv") — ACCESSORY_PRICES er kun en nødløsning, hvis intet
// produkt er tilknyttet endnu, eller opslaget en sjælden gang fejler.

async function getKubeBasePrice(bt, colorId) {
  const v = await getKubeVariant(bt, colorId);
  return v ? v.price / 100 : bt.price;
}

async function getFeatureAccessoryPrice(feature, colorId) {
  if (feature === 'drawers') {
    const v = await getAccessoryVariant('drawer', colorId);
    return v ? v.price / 100 : (ACCESSORY_PRICES.drawer ?? 0);
  }
  if (feature === 'door') {
    const v = await getAccessoryVariant('door', colorId);
    return v ? v.price / 100 : (ACCESSORY_PRICES.door ?? 0);
  }
  return 0;
}

async function getVaegbeslagPrice() {
  const v = await getVaegbeslagVariant();
  return v ? v.price / 100 : (ACCESSORY_PRICES.vaegbeslag ?? 0);
}

async function getSokkelPiecePrice(pieceSize) {
  const v = await getSokkelVariant(pieceSize);
  return v ? v.price / 100 : (ACCESSORY_PRICES.sokkel[pieceSize] ?? 0);
}

// Den SAMLEDE pris der vises på selve typekortet — basis + evt. tilkøb,
// så kunden ser den rigtige pris FØR de vælger, ikke bare skallens egen
// pris. (Sokkel/vægbeslag vises ikke her, da det afhænger af PLACERING,
// ikke af selve typevalget.)
async function getTypeDisplayPrice(bt, colorId) {
  const base = await getKubeBasePrice(bt, colorId);
  const accessory = await getFeatureAccessoryPrice(bt.feature, colorId);
  return (base || 0) + (accessory || 0);
}

// Kører værktøjet inde i selve Shopify-temaet? (anbefalet — se vores snak
// om arkitektur). Cart AJAX API'et virker kun same-origin. Hvis værktøjet
// i stedet ligger på et separat subdomæne, sæt denne til false og brug
// Storefront API + checkout-redirect i stedet (kræver ekstra opsætning).
const SHOPIFY_SAME_ORIGIN = true;

// Byg Shopify cart-items ud fra DB.stack. Async, fordi hver linje nu
// slås op live ved at matche farve/style mod Shopifys egne varianter
// (getKubeVariant m.fl.) i stedet for en hardcodet SKU-tabel.
async function buildShopifyCartItems() {
  const items = [];
  const missing = [];

  // Byg listen af opslag der skal køres, så vi kan køre dem parallelt i
  // stedet for sekventielt (hurtigere, færre ventetider).
  const lookups = [];
  const push = (promise, label, quantity) => {
    lookups.push({ promise, label, quantity: quantity || 1 });
  };

  DB.stack.forEach(box => {
    const bt = DB.types.find(t => t.id === box.typeId);
    if (!bt) return;
    push(getKubeVariant(bt, box.colorId), `${bt.code}_${box.colorId}`);

    // Skuffesæt håndteres IKKE her per kube — se groupDrawerColors()
    // nedenfor, da det sælges i sæt af 2 og rundes op per farve.
    if (bt.feature === 'door') {
      const colorKey = box.doorColorId || box.colorId;
      push(getAccessoryVariant('door', colorKey), `door_${colorKey}`);
    }
    // Understøtning: ETHVERT kube skal have sit EGET vægbeslag, MEDMINDRE
    // den står direkte på en sokkel — det gælder også kuber stablet oven
    // på en anden kube (de "arver" IKKE understøtningen fra kuben under
    // sig, hver kube skal fastgøres til væggen for sig). Derfor tjekkes
    // her mod ALT UNDTAGEN 'floor' (sokkel-understøttet bundrække) — ikke
    // kun 'wall' — så en stablet kube (support-type 'stacked') også
    // korrekt tælles med.
    if (getBoxSupportType(box) !== 'floor') {
      push(getVaegbeslagVariant(), 'vaegbeslag_default');
    }
  });

  // Skuffesæt: sælges i sæt af 2, rundes op PER FARVE (bekræftet — kan
  // ikke deles mellem farver, se groupDrawerColors()).
  groupDrawerColors().forEach(({ colorId, setsNeeded }) => {
    push(getAccessoryVariant('drawer', colorId), `drawer_${colorId}`, setsNeeded);
  });

  groupFloorRows().forEach(row => {
    sokkelPiecesForRow(row.length).forEach(pieceSize => {
      push(getSokkelVariant(pieceSize), `sokkel_${pieceSize}kube`);
    });
  });

  const resolved = await Promise.all(lookups.map(l => l.promise));
  resolved.forEach((variant, i) => {
    if (variant && variant.id) items.push({ id: variant.id, quantity: lookups[i].quantity });
    else missing.push(lookups[i].label);
  });

  return { items, missing };
}

// Tilføj hele opstillingen til Shopify-kurven og send kunden videre.
async function addToShopifyCart() {
  if (!DB.stack.length) {
    toast('Din opstilling er tom');
    return;
  }

  const btn = document.getElementById('shopifyCartBtn');
  if (btn) { btn.disabled = true; btn.textContent = 'Slår varer op…'; }

  const { items, missing } = await buildShopifyCartItems();

  if (!items.length) {
    toast('Ingen produkter fundet — tjek farve- og produkt-tilknytning i admin-appen');
    console.warn('Ingen Shopify-varianter fundet. Manglende nøgler:', missing);
    if (btn) { btn.disabled = false; btn.textContent = 'Læg i kurv'; }
    return;
  }
  if (missing.length) {
    console.warn('Nogle varianter mangler mapning og blev sprunget over:', missing);
  }

  // Uden for et rigtigt Shopify-tema (fx her i preview) kan vi ikke kalde
  // /cart/add.js — vis i stedet payloaden, så den kan tjekkes under udvikling.
  if (typeof window.Shopify === 'undefined' && !SHOPIFY_SAME_ORIGIN) {
    console.log('DEV-tilstand — ville have sendt til Shopify:', items);
    toast('Dev-tilstand: se konsollen for cart-payload');
    if (btn) { btn.disabled = false; btn.textContent = 'Læg i kurv'; }
    return;
  }

  if (btn) btn.textContent = 'Lægger i kurv…';

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      const errBody = await res.json().catch(() => ({}));
      throw new Error(errBody.description || `Shopify svarede ${res.status}`);
    }

    // Kurven er opdateret på Shopify-siden. Send kunden til /cart så de
    // ser det samme med det samme. (Kør temaets egen cart-drawer-event
    // her i stedet, hvis temaet understøtter det, fx:
    //   document.dispatchEvent(new CustomEvent('cart:refresh'));
    // — afhænger af hvilket tema I bruger.)
    window.location.href = '/cart';
  } catch (err) {
    console.error('Fejl ved tilføjelse til Shopify-kurv:', err);
    toast('Kunne ikke lægge i kurv — prøv igen');
    if (btn) { btn.disabled = false; btn.textContent = 'Læg i kurv'; }
  }
}


// Pandora Box — 3D-MOTOR + UI-KERNE
// Scene, kamera, træk/kollision, kasse-opbygning, hovedpanel, rum-panel.
// Afhænger af assets.js, data.js og shopify.js (til prisvisning).

// Pandora Box — app-logik (3D-motor, Shopify, admin, presets)
// Kræver pandora-box-assets.js indlæst FØR denne fil.
// RGBELoader for Three.js r128
THREE.RGBELoader = class extends THREE.DataTextureLoader {
  constructor(manager) { super(manager); this.type = THREE.HalfFloatType; }
  parse(buffer) {
    const NDEF=0,RLE=4;
    const decoder = new TextDecoder();
    let offset = 0;
    function readLine() {
      let end = offset;
      while (end < buffer.byteLength && buffer[end] !== 10) end++;
      const line = decoder.decode(buffer.slice(offset, end));
      offset = end + 1;
      return line;
    }
    // Read header
    let line, width=0, height=0;
    for (let i=0; i<20; i++) {
      line = readLine();
      if (line.match(/^-Y\s+(\d+)\s+\+X\s+(\d+)/)) {
        const m = line.match(/^-Y\s+(\d+)\s+\+X\s+(\d+)/);
        height = parseInt(m[1]); width = parseInt(m[2]); break;
      }
    }
    if (!width || !height) return null;
    const data = new Uint16Array(width * height * 4);
    const scanline = new Uint8Array(width * 4);
    for (let y = 0; y < height; y++) {
      // Read scanline header
      const r = buffer[offset++], g = buffer[offset++], b = buffer[offset++], e = buffer[offset++];
      if (r !== 2 || g !== 2 || (b & 0x80) !== 0) {
        // Old format - treat as uncompressed
        const exp = Math.pow(2, e - 128 - 8);
        const base = y * width * 4;
        data[base]   = THREE.DataUtils.toHalfFloat(r * exp);
        data[base+1] = THREE.DataUtils.toHalfFloat(g * exp);
        data[base+2] = THREE.DataUtils.toHalfFloat(b * exp);
        data[base+3] = THREE.DataUtils.toHalfFloat(1);
        continue;
      }
      const scanW = (b << 8) | e;
      // RLE decode 4 channels separately
      for (let ch = 0; ch < 4; ch++) {
        let x = 0;
        while (x < scanW) {
          const code = buffer[offset++];
          if (code > 128) { const val = buffer[offset++]; for (let k=0;k<code-128&&x<scanW;k++) scanline[x++ * 4 + ch] = val; }
          else { for (let k=0;k<code&&x<scanW;k++) scanline[x++ * 4 + ch] = buffer[offset++]; }
        }
      }
      const base = y * width * 4;
      for (let x = 0; x < scanW; x++) {
        const r2=scanline[x*4], g2=scanline[x*4+1], b2=scanline[x*4+2], e2=scanline[x*4+3];
        const exp = Math.pow(2, e2 - 128 - 8);
        data[base+x*4]   = THREE.DataUtils.toHalfFloat(r2 * exp);
        data[base+x*4+1] = THREE.DataUtils.toHalfFloat(g2 * exp);
        data[base+x*4+2] = THREE.DataUtils.toHalfFloat(b2 * exp);
        data[base+x*4+3] = THREE.DataUtils.toHalfFloat(1.0);
      }
    }
    return { width, height, data, format: THREE.RGBAFormat, type: THREE.HalfFloatType,
             colorSpace: THREE.LinearEncoding, flipY: true };
  }
};
// ═══════════════════════════════════════════
//  THREE SETUP
// ═══════════════════════════════════════════
let renderer, scene, camera;
// Orbit state
const orbit = { active:false, btn:0, startX:0, startY:0, theta:-0.2, phi:1.25, radius:1.760, targetTheta:-0.2, targetPhi:1.25, targetRadius:1.760, panX:0, panY:0.0736, targetPanX:0, targetPanY:0.0736 };
let is2D = false;
// Box meshes map: id -> THREE.Group
const meshMap = {};
// Drag state
const drag = { active:false, boxId:null, planeNormal:null, planePoint:null, offset:null, startWorld:null };


function initThree() {
  const canvas = document.getElementById('cvs');
  renderer = new THREE.WebGLRenderer({canvas, antialias:true, alpha:false});
  renderer.setClearColor(0xC8C4BE, 1);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;

  scene = new THREE.Scene();
  scene.fog = new THREE.Fog(0xC8C4BE, 5.8, 17.6);

  camera = new THREE.PerspectiveCamera(40, 1, 0.1, 200);
  updateCamera();

  // HDR environment map
  const hdrB64 = HDR_B64;
  const binaryStr = atob(hdrB64);
  const bytes = new Uint8Array(binaryStr.length);
  for (let i = 0; i < binaryStr.length; i++) bytes[i] = binaryStr.charCodeAt(i);
  const blob = new Blob([bytes], {type: 'application/octet-stream'});
  const hdrUrl = URL.createObjectURL(blob);
  new THREE.RGBELoader().load(hdrUrl, (hdrTex) => {
    hdrTex.mapping = THREE.EquirectangularReflectionMapping;
    scene.environment = hdrTex;
    // Don't set scene.background — we keep our custom wall/floor
    URL.revokeObjectURL(hdrUrl);
    rebuildScene();
  });

  // Lights
  scene.add(new THREE.AmbientLight(0x1E1E1E, 0.45));
  const sun = new THREE.DirectionalLight(0xfff8f0, 0.6);
  sun.position.set(0.480, 1.440, 0.864);
  sun.target.position.set(0, 0.1440, WALL_Z);
  scene.add(sun.target);
  sun.castShadow = true;
  sun.shadow.mapSize.set(4096, 4096);
  sun.shadow.camera.left  = -4.48;
  sun.shadow.camera.right =  4.48;
  sun.shadow.camera.top   =  4.48;
  sun.shadow.camera.bottom= -4.48;
  sun.shadow.camera.near  = 1;
  sun.shadow.camera.far   = 12.8;
  sun.shadow.bias = -0.001;
  sun.shadow.radius = 2;
  scene.add(sun);

  // Ground — controlled by floor type selector in Room panel
  window.floorMesh = new THREE.Mesh(new THREE.PlaneGeometry(500,500), new THREE.MeshStandardMaterial({color:0xD8D4CE, roughness:0.9, metalness:0.0}));
  floorMesh.rotation.x = -Math.PI/2; floorMesh.receiveShadow=true;
  scene.add(floorMesh);

    // Wall
  window.wallMesh = new THREE.Mesh(new THREE.PlaneGeometry(500, 500), new THREE.MeshStandardMaterial({color:0xC8C4BE, roughness:0.95, metalness:0.0}));
  wallMesh.position.set(0, 0, WALL_Z); wallMesh.receiveShadow=true;
  scene.add(wallMesh);

  // Baseboard
  const bm = new THREE.Mesh(new THREE.BoxGeometry(50, BASEBOARD_H, 0.06), new THREE.MeshStandardMaterial({color:0xD8D4CE, roughness:0.9, metalness:0.0}));
  bm.position.set(0, BASEBOARD_H/2, WALL_Z + 0.03); scene.add(bm);

  resizeThree();
  window.addEventListener('resize', resizeThree);
  setupInputs();
  animate();
}

function updateCamera() {
  const x = orbit.radius * Math.sin(orbit.phi) * Math.sin(orbit.theta) + orbit.panX;
  const y = orbit.radius * Math.cos(orbit.phi) + orbit.panY;
  const z = orbit.radius * Math.sin(orbit.phi) * Math.cos(orbit.theta);
  camera.position.set(x, y, z);
  camera.lookAt(orbit.panX, orbit.panY, 0);
}

// Zoom back placeholder (kept for button removal)
function zoomBack() {
  document.getElementById('zoomBackBtn').style.display = 'none';
}

function resizeThree() {
  const vp = document.getElementById('vp');
  const w = vp.clientWidth, h = vp.clientHeight;
  renderer.setSize(w, h);
  camera.aspect = w/h;
  camera.updateProjectionMatrix();
}

function animate() {
  requestAnimationFrame(animate);
  // Smooth orbit
  orbit.theta += (orbit.targetTheta - orbit.theta) * 0.07;
  orbit.phi   += (orbit.targetPhi   - orbit.phi)   * 0.07;
  orbit.radius+= (orbit.targetRadius- orbit.radius) * 0.07;
  orbit.panX  += (orbit.targetPanX  - orbit.panX)   * 0.07;
  orbit.panY  += (orbit.targetPanY  - orbit.panY)   * 0.07;
  // Clamp: theta limited so camera never goes behind wall; phi stays gentle top-down
  orbit.targetTheta = Math.max(-0.9, Math.min(0.9, orbit.targetTheta));
  orbit.phi = Math.max(0.3, Math.min(Math.PI / 2, orbit.phi));
  orbit.radius = Math.max(0.5, Math.min(35, orbit.radius));
  updateCamera();
  renderer.render(scene, camera);
  if (RS && RS.showDims) updateDimOverlay();
}

// ═══════════════════════════════════════════
//  INPUT (orbit + box drag)
// ═══════════════════════════════════════════
// Measures a box's ACTUAL on-screen width/height directly from its real
// rendered geometry — never assumes bt.w*SCL matches what's really drawn.
// This is exactly the same technique the selection outline uses, so
// collision math always agrees with what's visually on screen, regardless
// of any internal GLB scale calibration (which we never touch here).
function getVisualSize(group) {
  const savedPos = group.position.clone();
  group.position.set(0,0,0);
  group.updateMatrixWorld(true);
  const bbox = new THREE.Box3().setFromObject(group);
  group.position.copy(savedPos);
  group.updateMatrixWorld(true);
  const size = new THREE.Vector3();
  bbox.getSize(size);
  return { w: size.x, h: size.y };
}

// Push a box (given by size + desired position) out of any box it would
// overlap with. Shared by drag-repositioning AND initial placement in
// addBox(). Uses each box's REAL measured size (via getVisualSize), not
// the nominal bt.w*SCL/bt.h*SCL, so it correctly prevents overlap even
// when the rendered box doesn't exactly match its nominal dimensions.
// Sikkerhedsnet mod små (sub-mm) højde-uoverensstemmelser mellem to
// kuber, der egentlig SKAL stå i samme række — uanset den præcise årsag
// (snap-tolerance, flydende-komma-støj i selve trækket osv.), retter
// denne boksen ind efter den NÆRMESTE nabo i højden, hvis de allerede er
// tæt nok på hinanden til tydeligvis at være tiltænkt samme række.
function alignBoxToRowNeighbor(boxId) {
  const box = DB.stack.find(b => b.id === boxId);
  const g = meshMap[boxId];
  if (!box || !g) return;
  const ROW_TOL = 0.01; // ~1.25cm — fanger "samme række" uden at blande forskellige rækker sammen
  let bestY = null, bestDist = ROW_TOL;
  DB.stack.forEach(other => {
    if (other.id === boxId) return;
    const og = meshMap[other.id];
    if (!og) return;
    const d = Math.abs(og.position.y - g.position.y);
    if (d > 0 && d < bestDist) { bestDist = d; bestY = og.position.y; }
  });
  if (bestY !== null) {
    g.position.y = bestY;
    box.py = bestY;
  }
}

function resolveOverlap(boxId, bw, bh, x, y) {
  let snappedX = x, snappedY = y;
  let resolved = true;
  // Lille tolerance (~0.06mm) på selve overlap-tjekket: to bokse, der er
  // snappet til at røre hinanden PRÆCIST, kan ende en anelse "overlappende"
  // rent flydende-komma-mæssigt (afrundingsstøj fra skalerings-/snap-
  // beregningerne) — uden denne tolerance kunne det udløse et uønsket,
  // synligt lille skub (det var netop årsagen til det ~1mm "trin", der
  // kunne ses mellem to sammensnappede kuber).
  const EPS = 0.0005;
  for (let iter = 0; iter < 8 && resolved; iter++) {
    resolved = false;
    DB.stack.forEach(other => {
      if (other.id === boxId) return;
      const og = meshMap[other.id]; if (!og) return;
      const { w: obw, h: obh } = getVisualSize(og);
      const ox = og.position.x;
      const oy = og.position.y;
      // AABB overlap check (med lille tolerance, se ovenfor)
      const overlapX = (snappedX + bw/2) > (ox - obw/2 + EPS) && (snappedX - bw/2) < (ox + obw/2 - EPS);
      const overlapY = (snappedY + bh)   > (oy + EPS)          && snappedY           < (oy + obh - EPS);
      if (overlapX && overlapY) {
        // Find smallest push direction
        const pushRight = (ox + obw/2) - (snappedX - bw/2);
        const pushLeft  = (snappedX + bw/2) - (ox - obw/2);
        const pushUp    = (oy + obh) - snappedY;
        const pushDown  = (snappedY + bh) - oy;
        const minPush   = Math.min(pushRight, pushLeft, pushUp, pushDown);
        if (minPush === pushRight)       snappedX += pushRight;
        else if (minPush === pushLeft)   snappedX -= pushLeft;
        else if (minPush === pushUp)     snappedY  = oy + obh;
        else                             snappedY  = oy - bh;
        snappedY = Math.max(floorRestY(), snappedY);
        resolved = true;
      }
    });
  }
  // Fjerner resterende flydende-komma-støj (0.01mm-præcision — helt
  // usynligt visuelt, men forhindrer den støj i selv at blive stående og
  // give et akavet lille "trin" ved siden af en nabo-kube.
  return {
    x: Math.round(snappedX / 0.0001) * 0.0001,
    y: Math.round(snappedY / 0.0001) * 0.0001,
  };
}

// Bestemmer hvilken understøtning en kube reelt har brug for:
//  'stacked' — hviler oven på en anden kube i opstillingen → intet ekstra
//  'floor'   — står nederst på gulvet → Sokkel, HVIS sokkel-tilstand er slået til
//  'wall'    — hænger frit på væggen (eller er på gulvet uden sokkel-tilstand) → Vægbeslag
// Bruger den faktisk målte størrelse (getVisualSize), samme princip som
// kollisions-tjekket, så det stemmer overens med hvad der reelt er tegnet.
function getBoxSupportType(box) {
  const g = meshMap[box.id];
  if (!g) return 'wall';
  const { w: bw } = getVisualSize(g);
  const x = g.position.x, y = g.position.y;
  const TOL = 0.01; // lille tolerance for afrundingsfejl (world units)

  const isStacked = DB.stack.some(other => {
    if (other.id === box.id) return false;
    const og = meshMap[other.id]; if (!og) return false;
    const { w: obw, h: obh } = getVisualSize(og);
    const oTop = og.position.y + obh;
    const overlapsX = (x + bw/2) > (og.position.x - obw/2) && (x - bw/2) < (og.position.x + obw/2);
    return overlapsX && Math.abs(oTop - y) < TOL;
  });
  if (isStacked) return 'stacked';

  if (Math.abs(y - floorRestY()) < TOL) return S.sokkelOn ? 'floor' : 'wall';

  return 'wall';
}

// Grupperer gulv-stående kuber (support='floor') i sammenhængende rækker.
// Sokkel-produktet dækker en HEL RÆKKE ad gangen (1-4 kuber i træk), ikke
// én sokkel per kube — så kuber der reelt rører hinanden på gulvet hører
// til samme række; kuber med et mellemrum imellem hører til hver sin.
function groupFloorRows() {
  const floorItems = DB.stack
    .filter(box => getBoxSupportType(box) === 'floor')
    .map(box => {
      const g = meshMap[box.id];
      const { w } = getVisualSize(g);
      return { box, x: g.position.x, w };
    })
    .sort((a, b) => a.x - b.x);

  const TOUCH_TOL = 0.02; // ~2.5cm tolerance for "rører hinanden"
  const rows = [];
  let current = [];
  floorItems.forEach(item => {
    if (current.length) {
      const prev = current[current.length - 1];
      const gap = (item.x - item.w / 2) - (prev.x + prev.w / 2);
      if (gap > TOUCH_TOL) { rows.push(current); current = []; }
    }
    current.push(item);
  });
  if (current.length) rows.push(current);
  return rows; // array af arrays af {box, x, w}
}

// Sokkel findes kun i str. 1/2/3/4 kuber. Pak en række på n kuber med
// færrest mulige stykker (grådigt, størst variant først) —
// fx 5 kuber → [4,1], 7 kuber → [4,3].
// Fordeler antal kuber i en gulv-række på sokkel-stykker (maks 4 hver) —
// med FÆRREST MULIGE stykker, og derefter så JÆVNT fordelt som muligt
// (fx 6 → 3+3, ikke 4+2; 5 → 3+2, ikke 4+1) — mere visuelt pleasing end
// grådigt at tage det største stykke først og lade resten være rest.
function sokkelPiecesForRow(n) {
  if (n <= 0) return [];
  const numPieces = Math.ceil(n / 4);
  const base = Math.floor(n / numPieces);
  const remainder = n % numPieces;
  const pieces = [];
  for (let i = 0; i < numPieces; i++) {
    pieces.push(i < remainder ? base + 1 : base);
  }
  return pieces;
}

// "Skuffesæt til kube" sælges kun i sæt af 2 skuffer (bekræftet 499kr/sæt),
// og kan IKKE deles mellem farver — hver farve skuffe rundes selvstændigt
// op til nærmeste sæt. Fx: 1 lilla + 1 gul skuffe = 1 sæt lilla + 1 sæt
// gul (to fulde sæt, ikke ét blandet), selvom det tilsammen kun er 2
// skuffer i alt. Returnerer [{colorId, setsNeeded}, ...].
function groupDrawerColors() {
  const counts = {};
  DB.stack.forEach(box => {
    const bt = DB.types.find(t => t.id === box.typeId);
    if (!bt || bt.feature !== 'drawers') return;
    const colorId = box.drawerColorId != null ? box.drawerColorId : box.colorId;
    counts[colorId] = (counts[colorId] || 0) + 1;
  });
  // Ét "Skuffesæt til kube" dækker PRÆCIS én kube (begge skuffer i den
  // kube, ikke delt mellem to kuber) — derfor 1:1 med antal kuber, ikke
  // divideret med 2.
  return Object.keys(counts).map(colorId => ({
    colorId: Number(colorId),
    setsNeeded: counts[colorId],
  }));
}

function setupInputs() {
  const canvas = document.getElementById('cvs');

  canvas.addEventListener('contextmenu', e=>e.preventDefault());

  canvas.addEventListener('mousedown', e=>{
    const hit = raycastBoxes(e);
    if (hit && e.button===0) {
      // Shift+klik: tilføjer/fjerner boksen fra flervalget, uden at
      // starte et træk — samme princip som Windows/skrivebord.
      if (e.shiftKey) {
        if (S.multiSelIds.has(hit.boxId)) S.multiSelIds.delete(hit.boxId);
        else S.multiSelIds.add(hit.boxId);
        S.selId = S.multiSelIds.size ? [...S.multiSelIds][0] : null;
        refreshBox(hit.boxId);
        renderStack(); renderCustCtrls();
        return;
      }

      // Klikkes der på en boks, der ALLEREDE er del af et flervalg (mere
      // end 1 valgt) — bevar hele gruppen, så trækket flytter dem sammen.
      // Ellers: almindeligt klik nulstiller til kun denne ene boks.
      const clickedIsInGroup = S.multiSelIds.has(hit.boxId) && S.multiSelIds.size > 1;
      if (!clickedIsInGroup) {
        const prevIds = [...S.multiSelIds];
        S.multiSelIds = new Set([hit.boxId]);
        prevIds.forEach(id => { if (id !== hit.boxId) refreshBox(id); });
      }

      // Start dragging box
      drag.active = true;
      drag.boxId = hit.boxId;
      const boxPos = meshMap[hit.boxId].position;
      // Store 3D offset from box origin to hit point
      drag.offset = new THREE.Vector3(hit.point.x - boxPos.x, hit.point.y - boxPos.y, 0);
      // Flervalgs-trækdata — bruges kun hvis mere end 1 boks er valgt.
      drag.groupIds = [...S.multiSelIds];
      drag.groupAnchorStart = { x: boxPos.x, y: boxPos.y };
      drag.groupStartPositions = {};
      drag.groupLastValidDelta = { x: 0, y: 0 }; // sidst gyldige (kollisionsfrie) forskydning
      drag.groupIds.forEach(id => {
        const g = meshMap[id];
        if (g) drag.groupStartPositions[id] = { x: g.position.x, y: g.position.y };
      });
      canvas.classList.add('dragging');
      // Select this box — refresh old + new to update highlight
      const prevId = S.selId;
      S.selId = hit.boxId;
      if (prevId && prevId !== S.selId) refreshBox(prevId);
      refreshBox(S.selId);
      renderStack(); renderCustCtrls();
      setMode('cust');
      if(isMobile()){ openPanel(); }
    } else {
      // Clicked empty space — deselect (uændret adfærd, ingen klik-og-
      // træk-markering — det ville kollidere med kamera-rotationen).
      if (S.selId !== null || S.multiSelIds.size > 0) {
        const prevIds = [...new Set([...S.multiSelIds, S.selId].filter(Boolean))];
        S.selId = null;
        S.multiSelIds.clear();
        prevIds.forEach(id => refreshBox(id));
        renderStack(); renderCustCtrls();
      }
      // Orbit
      orbit.active = true;
      orbit.btn = e.button;
      orbit.startX = e.clientX;
      orbit.startY = e.clientY;
      canvas.classList.add('dragging');
    }
  });

  window.addEventListener('mousemove', e=>{
    if (drag.active) {
      const vp = document.getElementById('vp');
      const rect = vp.getBoundingClientRect();
      const mx = ((e.clientX - rect.left) / rect.width)  * 2 - 1;
      const my =-((e.clientY - rect.top)  / rect.height) * 2 + 1;
      const rc = new THREE.Raycaster();
      rc.setFromCamera({x:mx,y:my}, camera);

      // Project onto vertical wall plane (z = WALL_Z + small offset so ray hits)
      const wallPlane = new THREE.Plane(new THREE.Vector3(0,0,1), -(WALL_Z + 0.2));
      const wallHit = new THREE.Vector3();
      rc.ray.intersectPlane(wallPlane, wallHit);

      if (wallHit.lengthSq() > 0) {
        // FLERVALG: er mere end 1 kube valgt, flyttes de SAMMEN med en
        // fælles forskydning. Selve ANKER-kuben (den man rent faktisk
        // trækker i) snapper til ikke-valgte kuber, akkurat som ved et
        // enkelt-boks-træk — den resulterende forskydning lægges så på
        // HELE gruppen, så alle flytter sig ens, men gruppen som helhed
        // stadig kan snappe pænt op ad andre kuber. Kollisions-tjek mod
        // alle IKKE-valgte kuber forhindrer stadig, at gruppen glider ind
        // i en anden kube. Boksene i gruppen tjekkes ikke mod hinanden —
        // deres indbyrdes afstand ændres aldrig, når de flytter sig sammen.
        if (drag.groupIds && drag.groupIds.length > 1) {
          let newX = wallHit.x - drag.offset.x;
          let newY = wallHit.y - drag.offset.y;
          newY = Math.max(floorRestY(), newY);

          const anchorG = meshMap[drag.boxId];
          const { w: bw, h: bh } = getVisualSize(anchorG);
          let snappedX = newX, bestXDist = Infinity;
          let snappedY = newY, bestYDist = Infinity;
          const tryX = (candidate) => {
            const d = Math.abs(newX - candidate);
            if (d < SNAP_DIST && d < bestXDist) { bestXDist = d; snappedX = candidate; }
          };
          const tryY = (candidate) => {
            const d = Math.abs(newY - candidate);
            if (d < SNAP_DIST && d < bestYDist) { bestYDist = d; snappedY = candidate; }
          };
          DB.stack.forEach(other => {
            if (drag.groupIds.includes(other.id)) return; // snap ikke mod egne gruppe-medlemmer
            const og = meshMap[other.id]; if (!og) return;
            const { w: obw, h: obh } = getVisualSize(og);
            const ox = og.position.x, oy = og.position.y;
            tryX(ox + obw/2 + bw/2);
            tryX(ox - obw/2 - bw/2);
            [0, 0.25, 0.5, 0.75, 1].forEach(f => {
              const snapXPos = (ox - obw/2) + obw * f;
              tryX(snapXPos + bw/2);
              tryX(snapXPos - bw/2);
              tryX(snapXPos);
            });
            tryY(oy - bh);
            tryY(oy + obh);
            [0, 0.25, 0.5, 0.75, 1].forEach(f => {
              const snapYPos = oy + obh * f;
              tryY(snapYPos);
              tryY(snapYPos - bh);
              tryY(snapYPos - bh/2);
            });
          });
          snappedY = Math.max(floorRestY(), snappedY);

          const deltaX = snappedX - drag.groupAnchorStart.x;
          const deltaY = snappedY - drag.groupAnchorStart.y;

          const nonGroupBoxes = DB.stack.filter(b => !drag.groupIds.includes(b.id));
          let collision = false;
          for (const id of drag.groupIds) {
            const gm = meshMap[id];
            const start = drag.groupStartPositions[id];
            if (!gm || !start) continue;
            const { w: gbw, h: gbh } = getVisualSize(gm);
            const propX = start.x + deltaX;
            const propY = Math.max(floorRestY(), start.y + deltaY);
            for (const other of nonGroupBoxes) {
              const og = meshMap[other.id];
              if (!og) continue;
              const { w: obw, h: obh } = getVisualSize(og);
              const ox = og.position.x, oy = og.position.y;
              const overlapX = (propX + gbw/2) > (ox - obw/2) && (propX - gbw/2) < (ox + obw/2);
              const overlapY = (propY + gbh)   > oy             && propY            < (oy + obh);
              if (overlapX && overlapY) { collision = true; break; }
            }
            if (collision) break;
          }

          // Kun en KOLLISIONSFRI forskydning bliver den nye "sidst gyldige"
          // — opstår der en kollision, bliver gruppen stående ved sidste
          // gyldige position i stedet for at glide ind i den anden kube.
          if (!collision) drag.groupLastValidDelta = { x: deltaX, y: deltaY };
          const useDelta = drag.groupLastValidDelta;

          drag.groupIds.forEach(id => {
            const gm = meshMap[id];
            const start = drag.groupStartPositions[id];
            if (!gm || !start) return;
            gm.position.x = start.x + useDelta.x;
            gm.position.y = Math.max(floorRestY(), start.y + useDelta.y);
            const b = DB.stack.find(bx => bx.id === id);
            if (b) { b.px = gm.position.x; b.py = gm.position.y; }
          });
          renderSokkelPieces();
          return;
        }

        const g = meshMap[drag.boxId];
        const box = DB.stack.find(b=>b.id===drag.boxId);
        if (g && box) {
          // Real on-screen size of the box being dragged — not the
          // nominal bt.w/bt.h, so snapping and collision both match what's
          // actually rendered.
          const { w: bw, h: bh } = getVisualSize(g);

          let newX = wallHit.x - drag.offset.x;
          let newY = wallHit.y - drag.offset.y;

          // Clamp Y: bottom of box must be >= gulv-hvilehøjde (sokkel eller baseboard)
          newY = Math.max(floorRestY(), newY);

          // ── SNAP ──
          // Vælger den TÆTTESTE kandidat blandt alle snap-punkter, i
          // stedet for bare den sidst matchede i løkken (en mulig kilde
          // til upræcis snapning, endnu ikke bekræftet som den fulde
          // forklaring på det rapporterede ~1mm "trin" mellem to
          // sammensnappede kuber — under fortsat undersøgelse).
          let snappedX = newX, bestXDist = Infinity;
          let snappedY = newY, bestYDist = Infinity;
          const tryX = (candidate) => {
            const d = Math.abs(newX - candidate);
            if (d < SNAP_DIST && d < bestXDist) { bestXDist = d; snappedX = candidate; }
          };
          const tryY = (candidate) => {
            const d = Math.abs(newY - candidate);
            if (d < SNAP_DIST && d < bestYDist) { bestYDist = d; snappedY = candidate; }
          };

          DB.stack.forEach(other => {
            if (other.id === drag.boxId) return;
            const og = meshMap[other.id]; if (!og) return;
            const { w: obw, h: obh } = getVisualSize(og);
            const ox = og.position.x;
            const oy = og.position.y;

            // Snap X: edges and every 25% of other box width
            tryX(ox + obw/2 + bw/2);               // højre om denne, kant mod kant
            tryX(ox - obw/2 - bw/2);               // venstre om denne, kant mod kant
            [0, 0.25, 0.5, 0.75, 1].forEach(f => {
              const snapXPos = (ox - obw/2) + obw * f;
              tryX(snapXPos + bw/2);
              tryX(snapXPos - bw/2);
              tryX(snapXPos);
            });

            // Snap Y: edges and every 25% of other box height
            tryY(oy - bh);
            tryY(oy + obh);
            [0, 0.25, 0.5, 0.75, 1].forEach(f => {
              const snapYPos = oy + obh * f;
              tryY(snapYPos);
              tryY(snapYPos - bh);
              tryY(snapYPos - bh/2);
            });
          });

          // Re-apply gulv-hvilehøjde-clamp efter snap
          snappedY = Math.max(floorRestY(), snappedY);

          // ── COLLISION PREVENTION ──
          const resolvedPos = resolveOverlap(drag.boxId, bw, bh, snappedX, snappedY);
          snappedX = resolvedPos.x;
          snappedY = resolvedPos.y;

          g.position.x = snappedX;
          g.position.y = snappedY;
          box.px = snappedX;
          box.py = snappedY;
          renderSokkelPieces(); // sokkel skal følge med LIVE, mens man trækker — ikke kun efter slip
        }
      }
      return;
    }
    if (!orbit.active) {
      // Hover check
      const hit = raycastBoxes(e);
      document.getElementById('cvs').classList.toggle('over-box', !!hit);
      return;
    }
    const dx = e.clientX - orbit.startX;
    const dy = e.clientY - orbit.startY;
    orbit.startX = e.clientX; orbit.startY = e.clientY;
    if (!is2D) {
      if (orbit.btn === 0) {
        orbit.targetTheta -= dx * 0.003;
        orbit.targetPhi   += dy * 0.003;
      } else if (orbit.btn === 2) {
        orbit.targetPanX -= dx * 0.005;
        orbit.targetPanY += dy * 0.005;
      }
    }
  });

  window.addEventListener('mouseup', ()=>{
    // Sidste sikkerhedsnet: uanset hvor en lille (sub-mm) højde-uoverens-
    // stemmelse måtte komme fra under selve trækket, retter dette den
    // synlige boks ind efter en nabo i samme "række" (samme højde inden
    // for en lille tolerance), så to kuber ved siden af hinanden ALTID
    // ender med præcis samme Y — ikke bare "tæt på".
    if (drag.boxId) alignBoxToRowNeighbor(drag.boxId);
    orbit.active = false; drag.active = false; drag.boxId = null;
    document.getElementById('cvs').classList.remove('dragging');
    center2DCamera();
  });

  canvas.addEventListener('wheel', e=>{
    e.preventDefault();
    if (!is2D) orbit.targetRadius += e.deltaY * 0.004;
  }, {passive:false});

  // Touch
  let lastTouchDist = 0, lastTouchX = 0, lastTouchY = 0, touchMoved = false;
  canvas.addEventListener('touchstart', e=>{
    e.preventDefault();
    touchMoved = false;
    if (e.touches.length===1) { lastTouchX=e.touches[0].clientX; lastTouchY=e.touches[0].clientY; }
    if (e.touches.length===2) {
      const dx=e.touches[0].clientX-e.touches[1].clientX, dy=e.touches[0].clientY-e.touches[1].clientY;
      lastTouchDist=Math.sqrt(dx*dx+dy*dy);
    }
  },{passive:false});
  canvas.addEventListener('touchend', e=>{
    // Tap = no significant movement → treat as click/select
    if(!touchMoved && e.changedTouches.length===1){
      const fakeEv={clientX:e.changedTouches[0].clientX, clientY:e.changedTouches[0].clientY};
      const hit=raycastBoxes(fakeEv);
      if(hit){
        const prevId=S.selId;
        S.selId=hit.boxId;
        if(prevId&&prevId!==S.selId)refreshBox(prevId);
        refreshBox(S.selId);
        renderStack();renderCustCtrls();
        if(isMobile()){setMode('cust');openPanel();}
      } else {
        // Tap empty — close panel on mobile
        if(isMobile()) document.querySelector('.panel').classList.remove('open');
      }
    }
  },{passive:true});
  canvas.addEventListener('touchmove', e=>{
    e.preventDefault();
    touchMoved = true;
    if (e.touches.length===1) {
      const dx=e.touches[0].clientX-lastTouchX, dy=e.touches[0].clientY-lastTouchY;
      lastTouchX=e.touches[0].clientX; lastTouchY=e.touches[0].clientY;
      if (!is2D) { orbit.targetTheta-=dx*.003; orbit.targetPhi+=dy*.003; }
    }
    if (e.touches.length===2 && !is2D) {
      const dx=e.touches[0].clientX-e.touches[1].clientX, dy=e.touches[0].clientY-e.touches[1].clientY;
      const dist=Math.sqrt(dx*dx+dy*dy);
      orbit.targetRadius -= (dist-lastTouchDist)*0.015;
      lastTouchDist=dist;
    }
  },{passive:false});
}

function getWorldPos(e, y) {
  const vp = document.getElementById('vp');
  const rect = vp.getBoundingClientRect();
  const mx = ((e.clientX - rect.left) / rect.width)  * 2 - 1;
  const my =-((e.clientY - rect.top)  / rect.height) * 2 + 1;
  const raycaster = new THREE.Raycaster();
  raycaster.setFromCamera({x:mx,y:my}, camera);
  const plane = new THREE.Plane(new THREE.Vector3(0,1,0), -y);
  const target = new THREE.Vector3();
  raycaster.ray.intersectPlane(plane, target);
  return target.lengthSq() > 0 ? target : null;
}

function raycastBoxes(e) {
  const vp = document.getElementById('vp');
  const rect = vp.getBoundingClientRect();
  const mx = ((e.clientX - rect.left) / rect.width)  * 2 - 1;
  const my =-((e.clientY - rect.top)  / rect.height) * 2 + 1;
  const rc = new THREE.Raycaster();
  rc.setFromCamera({x:mx,y:my}, camera);
  const objs = [];
  Object.entries(meshMap).forEach(([id,g])=>{ g.traverse(c=>{ if(c.isMesh) objs.push(c); }); });
  const hits = rc.intersectObjects(objs, false);
  if (!hits.length) return null;
  const hitMesh = hits[0].object;
  let boxId = null;
  Object.entries(meshMap).forEach(([id,g])=>{ g.traverse(c=>{ if(c===hitMesh) boxId=parseInt(id); }); });
  return boxId ? { boxId, point:hits[0].point } : null;
}

// ═══════════════════════════════════════════
//  BOX MESH BUILDER
// ═══════════════════════════════════════════

// Cache af INDLÆSTE (parsede) 3D-modeller for admin-oprettede bokstyper —
// {typeId: THREE.Group} — ALDRIG tilføjet direkte til scenen, kun brugt
// som skabelon der klones for hver enkelt boks. Fyldes af
// preloadCustomTypeModels() ved opstart.
const CUSTOM_MODEL_CACHE = {};

// Cache af admin-uploadede ERSTATNINGS-modeller for de 5 indbyggede dele
// — {kube|hylde_shelf|hylde|skuffe|laage: THREE.Group}. Fyldes af
// preloadBuiltinModels() ved opstart. Mangler en nøgle, betyder det bare
// "brug den indbyggede model" — se hver anvendelse i buildBox() nedenfor.
const BUILTIN_MODEL_CACHE = {};

// Klon en cached admin-model ind i en gruppe, skaleret til de faktiske mål
// (targetW/H/D) ud fra modellens EGEN målte størrelse — uploadede .glb-
// filer sjældent deler samme skala-konvention som de indbyggede modeller.
// Centrerer om x/z, bund ved y=0. Bruges kun til selve skallen, som skal
// ramme de eksakte mål uanset sin egen native proportion.
// Placerer en klonet admin-model i gruppen — INGEN skalering, kun
// centrering (x/z) og bund-ved-gulv (y). Modellerne bruges 1:1 som de er
// uploadet; kun placeringen justeres, aldrig størrelsen.
// Selve 3D-scenen bruger IKKE "1 world unit = 1 meter" — den bruger sin
// egen skala (udledt fra BASEBOARD_H, som er 1.8cm i virkeligheden, men
// 0.0144 world units i scenen → 1.8/0.0144/100 = 0.8). Jeres uploadede
// modeller er eksporteret i RIGTIGE meter (bekræftet af "Se model"), så
// de skal ganges med denne ENE, faste faktor for at ende i den rigtige
// skala i scenen — det er en enheds-omregning, IKKE en størrelses-
// tilpasning (derfor er den ens for alle 5 dele, uanset deres form).
const MODEL_UNIT_SCALE = 0.8;

function placeClonedBuiltinModel(template, group, colorHex, texUrl, offsetKey) {
  const clone = cloneModel(template);

  const box = new THREE.Box3().setFromObject(clone);
  const size = new THREE.Vector3(); box.getSize(size);
  const center = new THREE.Vector3(); box.getCenter(center);

  // Admin-appens gemte X/Y/Z-justering for denne del (0 hvis ingen sat).
  const off = (offsetKey && BUILTIN_MODEL_OFFSETS[offsetKey]) || { x: 0, y: 0, z: 0 };

  clone.scale.set(MODEL_UNIT_SCALE, MODEL_UNIT_SCALE, MODEL_UNIT_SCALE);
  clone.position.set(
    -center.x * MODEL_UNIT_SCALE + off.x,
    -center.y * MODEL_UNIT_SCALE + (size.y * MODEL_UNIT_SCALE) / 2 + off.y, // bund ved y=0 (gulv-konvention) + admin-justering
    -center.z * MODEL_UNIT_SCALE + off.z                                     // centreret om 0 (væg-konvention) + admin-justering
  );

  applyBuiltinModelMaterials(clone, colorHex, texUrl);
  group.add(clone);
  // Returnerer den SKALEREDE størrelse (world units, ikke rå meter) — så
  // en evt. efterfølgende udregning (som centrering af hylden/skuffen)
  // regner i samme enhed som resten af scenen, i stedet for at blande
  // meter og world units sammen ved et uheld.
  const scaledSize = size.clone().multiplyScalar(MODEL_UNIT_SCALE);
  return { clone, size: scaledSize };
}

// Box-projection UV: projects texture onto each face based on dominant normal.
// UVs are normalized 0→1 across each face's actual extent, so texture
// fills each face perfectly exactly once, regardless of whatever UVs the
// GLB itself was exported with (fixes textures that otherwise tile 3-4x
// on the built-in models, since their baked-in UVs aren't 0→1 per face).
function boxProjectUV(geo) {
  const posArr = geo.attributes.position.array;
  const norArr = geo.attributes.normal.array;
  const n = posArr.length / 3;
  const uvArr = new Float32Array(n * 2);

  // First pass: assign raw world-position UVs per face axis
  const rawU = new Float32Array(n);
  const rawV = new Float32Array(n);
  for (let i = 0; i < n; i++) {
    const nx = norArr[i*3], ny = norArr[i*3+1], nz = norArr[i*3+2];
    const px = posArr[i*3],  py = posArr[i*3+1], pz = posArr[i*3+2];
    const ax = Math.abs(nx), ay = Math.abs(ny), az = Math.abs(nz);
    if      (ax >= ay && ax >= az) { rawU[i] = pz; rawV[i] = py; } // sides
    else if (ay >= ax && ay >= az) { rawU[i] = px; rawV[i] = pz; } // top/bottom
    else                           { rawU[i] = px; rawV[i] = py; } // front/back
  }

  // Second pass: normalize each face's UVs to 0→1
  // Group vertices by their dominant normal direction
  const EPS = 0.5;
  const processed = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    if (processed[i]) continue;
    const nx = norArr[i*3], ny = norArr[i*3+1], nz = norArr[i*3+2];
    // Find all vertices on same face (same normal direction)
    const group = [];
    for (let j = i; j < n; j++) {
      if (Math.abs(norArr[j*3]-nx) < EPS &&
          Math.abs(norArr[j*3+1]-ny) < EPS &&
          Math.abs(norArr[j*3+2]-nz) < EPS) {
        group.push(j);
        processed[j] = 1;
      }
    }
    // Find min/max of raw UVs for this face
    let minU = Infinity, maxU = -Infinity, minV = Infinity, maxV = -Infinity;
    for (const j of group) {
      if (rawU[j] < minU) minU = rawU[j];
      if (rawU[j] > maxU) maxU = rawU[j];
      if (rawV[j] < minV) minV = rawV[j];
      if (rawV[j] > maxV) maxV = rawV[j];
    }
    const rangeU = maxU - minU || 1;
    const rangeV = maxV - minV || 1;
    // Normalize to 0→1
    for (const j of group) {
      uvArr[j*2]   = (rawU[j] - minU) / rangeU;
      uvArr[j*2+1] = (rawV[j] - minV) / rangeV;
    }
  }
  geo.setAttribute('uv', new THREE.BufferAttribute(uvArr, 2));
}

function applyBuiltinModelMaterials(clone, colorHex, texUrl) {
  clone.traverse(c => {
    if (!c.isMesh) return;
    const matName = (c.material && c.material.name) || '';
    if (matName.startsWith('Chrome')) {
      c.material = new THREE.MeshStandardMaterial({color: 0xf3f6f4, roughness: 0.5, metalness: 0.8});
    } else if (texUrl) {
      // Re-project UVs so the texture covers each face exactly once,
      // instead of tiling per the model's own (denser) baked-in UVs.
      if (c.geometry && c.geometry.attributes.normal) {
        boxProjectUV(c.geometry);
      }
      const t = new THREE.TextureLoader().load(texUrl);
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      t.encoding = THREE.sRGBEncoding;
      t.anisotropy = 8;
      c.material = new THREE.MeshStandardMaterial({map: t, color: 0xffffff, roughness: 0.72, metalness: 0.0});
    } else {
      c.material = new THREE.MeshStandardMaterial({color: new THREE.Color(colorHex), roughness: 0.75, metalness: 0.0});
    }
    c.castShadow = true; c.receiveShadow = true;
  });
}

// Bygger en boks for en admin-oprettet bokstype (uploadet .glb) — en helt
// anden, langt simplere sti end de 4 indbyggede typer: ingen skuffe/låge/
// hylde-logik, bare et coloreret/tekstureret skal ud fra selve modellen.
function buildCustomBox(bt, colorHex, texUrl) {
  const group = new THREE.Group();
  const bw = bt.w * SCL, bh = bt.h * SCL, bd = bt.d * SCL;
  const template = CUSTOM_MODEL_CACHE[bt.id];

  if (template) {
    const clone = cloneModel(template);
    const box = new THREE.Box3().setFromObject(clone);
    const size = new THREE.Vector3(); box.getSize(size);
    const center = new THREE.Vector3(); box.getCenter(center);
    // Samme faste enheds-omregning som resten af filen (MODEL_UNIT_SCALE)
    // — IKKE en per-akse tilpasning til de erklærede mål. De erklærede
    // mål (bt.w/h/d) er i praksis altid = modellens egen målte størrelse
    // × 0.8 alligevel (admin-appen måler dem direkte fra modellen), så
    // denne udregning gav samme resultat, men risikerede at FORVRÆNGE
    // modellen (strække akser forskelligt), hvis nogen nogensinde ændrede
    // et mål manuelt uden at matche modellen. Ensartet skala forvrænger
    // aldrig, uanset hvad.
    clone.scale.set(MODEL_UNIT_SCALE, MODEL_UNIT_SCALE, MODEL_UNIT_SCALE);
    clone.position.set(
      -center.x * MODEL_UNIT_SCALE,
      -center.y * MODEL_UNIT_SCALE + bh / 2,
      -center.z * MODEL_UNIT_SCALE
    );

    clone.traverse(c => {
      if (!c.isMesh) return;
      // Samme princip som resten af filen: dele med et materialenavn der
      // starter med "Chrome" bliver krom/metal, resten farves/textureres
      // med kundens valg.
      const matName = (c.material && c.material.name) || '';
      if (matName.startsWith('Chrome')) {
        c.material = new THREE.MeshStandardMaterial({color: 0xf3f6f4, roughness: 0.5, metalness: 0.8});
      } else if (texUrl) {
        const t = new THREE.TextureLoader().load(texUrl);
        t.wrapS = t.wrapT = THREE.RepeatWrapping;
        t.encoding = THREE.sRGBEncoding;
        t.anisotropy = 8;
        c.material = new THREE.MeshStandardMaterial({map: t, color: 0xffffff, roughness: 0.7, metalness: 0.0});
      } else {
        c.material = new THREE.MeshStandardMaterial({color: new THREE.Color(colorHex), roughness: 0.75, metalness: 0.0});
      }
      c.castShadow = true; c.receiveShadow = true;
      c.userData.isShell = true; // så outline/bbox-beregning (refreshBox) fungerer som for de andre
    });
    group.add(clone);
  } else {
    // Modellen er enten ikke uploadet endnu, eller ikke færdig med at
    // hente — vis en simpel farvet kasse i stedet for at fejle helt.
    const mat = new THREE.MeshStandardMaterial({color: new THREE.Color(colorHex), roughness: 0.75, metalness: 0.0});
    const shell = new THREE.Mesh(new THREE.BoxGeometry(bw, bh, bd), mat);
    shell.position.set(0, bh/2, bd/2);
    shell.castShadow = true; shell.receiveShadow = true;
    shell.userData.isShell = true;
    group.add(shell);
  }

  return { group, bw, bh, bd };
}

function buildBox(bt, colorHex, texUrl, featureOn, drawerColorHex, drawerTexUrl, doorColorHex, doorTexUrl, doorHandleLeft) {
  // Admin-oprettede bokstyper (uploadet via "3D-modeller"-fanen) — en helt
  // anden, simplere sti end de 4 indbyggede: ingen skuffe/låge/hylde-logik,
  // bare farvevalg. Modellen er allerede hentet/cachet på forhånd (se
  // preloadCustomTypeModels) — så det her forbliver synkront, akkurat som
  // resten af buildBox().
  if (bt.feature === 'custom') {
    return buildCustomBox(bt, colorHex, texUrl);
  }

  drawerColorHex = drawerColorHex || colorHex;
  doorColorHex   = doorColorHex   || colorHex;
  drawerTexUrl   = drawerTexUrl   || null;
  const drawerCol = new THREE.Color(drawerColorHex);
  const group = new THREE.Group();
  const bw=bt.w*SCL, bh=bt.h*SCL, bd=bt.d*SCL;
  const col = new THREE.Color(colorHex);

  // Make a material for a face — texture stretches exactly once, no tiling
  function makeMat(tintMul, faceW, faceH) {
    const c = col.clone().multiplyScalar(tintMul);
    if (texUrl) {
      const t = new THREE.TextureLoader().load(texUrl);
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      t.encoding = THREE.sRGBEncoding;
      t.anisotropy = 8;
      t.repeat.set(1.5, 1.5);
      return new THREE.MeshStandardMaterial({map: t, color: 0xffffff, roughness:0.7, metalness:0.0});
    }
    return new THREE.MeshStandardMaterial({color: c, roughness:0.75, metalness:0.0});
  }

  const matFront  = makeMat(1.00, bw, bh);   // front face
  const matTop    = makeMat(1.08, bw, bd);   // top — slightly lighter
  const matSide   = makeMat(0.82, bd, bh);   // sides — darker
  const matInner  = makeMat(0.80, bw, bh);   // inner panels
  const mat       = matFront;                 // default (bottom, back)

  function panel(w,h,d,x,y,z,m) {
    const mesh = new THREE.Mesh(new THREE.BoxGeometry(w,h,d), m||mat);
    mesh.position.set(x,y,z); mesh.castShadow=true; mesh.receiveShadow=true;
    mesh.userData.isShell = true; // only used for the fallback shell — outline follows only this
    group.add(mesh);
  }

  // Box-projection UV: projects texture onto each face based on dominant normal.
  // UVs are normalized 0→1 across each face's actual extent, so texture
  // fills each face perfectly regardless of face size.
  function boxProjectUV(geo, nativeW) {
    const posArr = geo.attributes.position.array;
    const norArr = geo.attributes.normal.array;
    const n = posArr.length / 3;
    const uvArr = new Float32Array(n * 2);

    // First pass: assign raw world-position UVs per face axis
    const rawU = new Float32Array(n);
    const rawV = new Float32Array(n);
    for (let i = 0; i < n; i++) {
      const nx = norArr[i*3], ny = norArr[i*3+1], nz = norArr[i*3+2];
      const px = posArr[i*3],  py = posArr[i*3+1], pz = posArr[i*3+2];
      const ax = Math.abs(nx), ay = Math.abs(ny), az = Math.abs(nz);
      if      (ax >= ay && ax >= az) { rawU[i] = pz; rawV[i] = py; } // sides
      else if (ay >= ax && ay >= az) { rawU[i] = px; rawV[i] = pz; } // top/bottom
      else                           { rawU[i] = px; rawV[i] = py; } // front/back
    }

    // Second pass: normalize each face's UVs to 0→1
    // Group vertices by their dominant normal direction
    const EPS = 0.5;
    const processed = new Uint8Array(n);
    for (let i = 0; i < n; i++) {
      if (processed[i]) continue;
      const nx = norArr[i*3], ny = norArr[i*3+1], nz = norArr[i*3+2];
      // Find all vertices on same face (same normal direction)
      const group = [];
      for (let j = i; j < n; j++) {
        if (Math.abs(norArr[j*3]-nx) < EPS &&
            Math.abs(norArr[j*3+1]-ny) < EPS &&
            Math.abs(norArr[j*3+2]-nz) < EPS) {
          group.push(j);
          processed[j] = 1;
        }
      }
      // Find min/max of raw UVs for this face
      let minU = Infinity, maxU = -Infinity, minV = Infinity, maxV = -Infinity;
      for (const j of group) {
        if (rawU[j] < minU) minU = rawU[j];
        if (rawU[j] > maxU) maxU = rawU[j];
        if (rawV[j] < minV) minV = rawV[j];
        if (rawV[j] > maxV) maxV = rawV[j];
      }
      const rangeU = maxU - minU || 1;
      const rangeV = maxV - minV || 1;
      // Normalize to 0→1
      for (const j of group) {
        uvArr[j*2]   = (rawU[j] - minU) / rangeU;
        uvArr[j*2+1] = (rawV[j] - minV) / rangeV;
      }
    }
    geo.setAttribute('uv', new THREE.BufferAttribute(uvArr, 2));
  }

  // Load texture with RepeatWrapping
  function loadTex(url) {
    const t = new THREE.TextureLoader().load(url);
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    t.encoding = THREE.sRGBEncoding;
    t.anisotropy = 8;
    return t;
  }

  // Build a GLB mesh with box-projection UV if texture available
  function buildGLBMesh(prim, texUrl, colorHex, nativeW, tintMul) {
    const geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(new Float32Array(prim.pos), 3));
    geo.setAttribute('normal',   new THREE.BufferAttribute(new Float32Array(prim.nor), 3));
    geo.setIndex(new THREE.BufferAttribute(new Uint32Array(prim.idx), 1));
    if (texUrl) {
      boxProjectUV(geo, nativeW);
      const t = loadTex(texUrl);
      return new THREE.MeshStandardMaterial({map: t, color: 0xffffff, roughness: 0.72, metalness: 0.0});
    }
    const c = new THREE.Color(colorHex).multiplyScalar(tintMul !== undefined ? tintMul : 1.0);
    return new THREE.MeshStandardMaterial({color: c, roughness: 0.75, metalness: 0.0});
  }

  // Skal — HENTES UDELUKKENDE fra admin-appen. Findes ingen uploadet
  // model (fx allerførste besøg efter en frisk installation), tegnes en
  // simpel nødkasse i stedet, i stedet for at fejle helt.
  if (BUILTIN_MODEL_CACHE.kube) {
    const { clone } = placeClonedBuiltinModel(BUILTIN_MODEL_CACHE.kube, group, colorHex, texUrl, 'kube');
    clone.traverse(c => { if (c.isMesh) c.userData.isShell = true; }); // outline følger kun skallen
  } else {
    panel(bw,THICK,bd,        0,    0,    0, mat);
    panel(bw,THICK,bd,        0,    bh,   0, matTop);
    panel(THICK,bh,bd,       -bw/2+THICK/2, bh/2, 0, matSide);
    panel(THICK,bh,bd,        bw/2-THICK/2, bh/2, 0, matSide);
    panel(bw,bh+THICK,THICK,  0,    bh/2, -bd/2+THICK/2, matFront);
  }

  const feat = (bt.feature === 'drawers' || bt.feature === 'shelf' || bt.feature === 'door') ? bt.feature : (featureOn ? bt.feature : 'open');

  if (feat==='shelf') {
    if (BUILTIN_MODEL_CACHE.hylde_shelf) {
      placeClonedBuiltinModel(BUILTIN_MODEL_CACHE.hylde_shelf, group, colorHex, texUrl, 'hylde_shelf');
    } else {
      const sm = new THREE.Mesh(new THREE.BoxGeometry(bw-THICK*2,THICK,bd-THICK), makeMat(0.88, bw, bd));
      sm.position.set(0,bh*0.48,0); sm.castShadow=true; group.add(sm);
    }
  }
  if (feat==='drawers') {
    if (BUILTIN_MODEL_CACHE.skuffe) {
      const { clone: skuffeClone } = placeClonedBuiltinModel(BUILTIN_MODEL_CACHE.skuffe, group, drawerColorHex, drawerTexUrl, 'skuffe');
      if (BUILTIN_MODEL_CACHE.hylde) {
        const { clone: hyldeClone } = placeClonedBuiltinModel(BUILTIN_MODEL_CACHE.hylde, group, colorHex, texUrl, 'hylde');
      }
    } else {
      const dm = makeMat(0.70, bw, bh*0.29);
      const hm = new THREE.MeshStandardMaterial({color:0xB8A890, roughness:0.4, metalness:0.7});
      [0.23, 0.65].forEach(f=>{
        const d = new THREE.Mesh(new THREE.BoxGeometry(bw-THICK*2-0.01, bh*0.29, 0.045), dm);
        d.position.set(0, bh*f, bd/2-THICK/2-0.01); d.castShadow=true; group.add(d);
        const h = new THREE.Mesh(new THREE.BoxGeometry(bw*0.28,0.018,0.018), hm);
        h.position.set(0, bh*f, bd/2+0.028); group.add(h);
      });
    }
  }
  if (feat==='door') {
    if (BUILTIN_MODEL_CACHE.laage) {
      // INGEN skalering — modellen bruges 1:1 som den er uploadet, kun
      // placeringen beregnes.
      const rawBox = new THREE.Box3().setFromObject(BUILTIN_MODEL_CACHE.laage);
      const rawSize = new THREE.Vector3(); rawBox.getSize(rawSize);
      const rawCenter = new THREE.Vector3(); rawBox.getCenter(rawCenter);
      // Samme enheds-omregning som skallen/skuffe/hylde ovenfor — ikke en
      // størrelses-tilpasning, kun meter → world-units.
      const glbScale = MODEL_UNIT_SCALE;
      const clone = cloneModel(BUILTIN_MODEL_CACHE.laage);
      clone.scale.set(doorHandleLeft ? -glbScale : glbScale, glbScale, glbScale);

      const shellFrontZ = bd / 2; // skallens front (ny konvention, centreret om 0)
      const doorFrontZ  = rawBox.max.z * glbScale;
      const doorZOffset = shellFrontZ - doorFrontZ;
      // Admin-appens gemte X/Y/Z-justering for lågen (0 hvis ingen sat) —
      // erstatter de tidligere hardcodede tal i selve koden.
      const off = BUILTIN_MODEL_OFFSETS.laage || { x: 0, y: 0, z: 0 };
      const doorXOffset = -rawCenter.x * (doorHandleLeft ? -glbScale : glbScale) + off.x;
      clone.position.set(doorXOffset, -rawBox.min.y * glbScale + off.y, doorZOffset + off.z);
      clone.traverse(c => {
        if (!c.isMesh) return;
        const matName = (c.material && c.material.name) || '';
        if (matName.startsWith('Chrome')) {
          c.material = new THREE.MeshStandardMaterial({color: 0xf3f6f4, roughness: 0.5, metalness: 0.8});
        } else if (doorTexUrl) {
          const t = new THREE.TextureLoader().load(doorTexUrl);
          t.wrapS = t.wrapT = THREE.RepeatWrapping;
          t.encoding = THREE.sRGBEncoding;
          t.anisotropy = 8;
          c.material = new THREE.MeshStandardMaterial({map: t, color: 0xffffff, roughness: 0.7, metalness: 0.0});
        } else {
          c.material = new THREE.MeshStandardMaterial({color: new THREE.Color(doorColorHex), roughness: 0.75, metalness: 0.0});
        }
        if (doorHandleLeft) c.material.side = THREE.DoubleSide;
        c.castShadow = true; c.receiveShadow = true;
      });
      group.add(clone);
    } else {
      const dm = makeMat(0.76, bw*0.47, bh);
      // Panel og greb bytter side om x=0, når håndtaget er sat til venstre.
      const panelX = doorHandleLeft ? bw*0.245 : -bw*0.245;
      const knobX  = doorHandleLeft ? bw*0.02  : -bw*0.02;
      const d = new THREE.Mesh(new THREE.BoxGeometry(bw*0.47-THICK, bh-THICK*3, 0.03), dm);
      d.position.set(panelX, bh/2, bd/2-0.005); d.castShadow=true; group.add(d);
      const km = new THREE.MeshStandardMaterial({color:0x998880, roughness:0.3, metalness:0.8});
      const k = new THREE.Mesh(new THREE.SphereGeometry(0.022,8,8), km);
      k.position.set(knobX, bh/2, bd/2+0.04); group.add(k);
    }
  }

  return {group, bw, bh, bd};
}

// ═══════════════════════════════════════════
//  SCENE REBUILD
// ═══════════════════════════════════════════
function rebuildScene() {
  Object.values(meshMap).forEach(g=>scene.remove(g));
  for(const k in meshMap) delete meshMap[k];

  document.getElementById('emptyState').style.display = DB.stack.length?'none':'flex';

  DB.stack.forEach(box=>{
    const bt = DB.types.find(t=>t.id===box.typeId)||DB.types[0];
    const col= DB.colors.find(c=>c.id===box.colorId)||DB.colors[0]||FALLBACK_COLOR;
    const texUrl = col.tex || null;
    const drawerCol = DB.colors.find(c=>c.id===(box.drawerColorId||box.colorId))||col;
    const doorCol   = DB.colors.find(c=>c.id===(box.doorColorId  ||box.colorId))||col;
    const {group, bw, bh, bd} = buildBox(bt, col.hex, texUrl, box.featureOn||false, drawerCol.hex, drawerCol.tex||null, doorCol.hex, doorCol.tex||null, box.doorHandleLeft||false);

    const zPos = WALL_Z + bd/2 + 0.0016;
    const xPos = box.px !== undefined ? box.px : 0;
    const yPos = box._noSnap ? (box.py||floorRestY()) : (box.py !== undefined ? Math.max(floorRestY(), box.py) : floorRestY());
    delete box._noSnap;
    group.position.set(xPos, yPos, zPos);
    box.px = xPos; box.py = yPos; box.pz = zPos;

    // Selection highlight — white edge outline + subtle emissive glow on
    // the real materials. Outline follows ONLY the box shell (meshes
    // tagged isShell in buildBox) — not shelf/drawer/door hardware, which
    // can protrude past the shell's own footprint (handles, knobs).
    if (box.id===S.selId || S.multiSelIds.has(box.id)) {
      const savedPos = group.position.clone();
      group.position.set(0,0,0);
      group.updateMatrixWorld(true);
      const bbox = new THREE.Box3();
      bbox.makeEmpty();
      group.traverse(c => { if (c.isMesh && c.userData.isShell) bbox.expandByObject(c); });
      group.position.copy(savedPos);
      group.updateMatrixWorld(true);
      const size = new THREE.Vector3(); bbox.getSize(size);
      const center = new THREE.Vector3(); bbox.getCenter(center);
      // Tiny margin (~1mm total) just to avoid z-fighting with the box's
      // own surface — the previous +0.01 was 1.25cm in real terms (SCL is
      // 0.008 world-units-per-cm), which visibly oversized the outline.
      const outlineGeo = new THREE.BoxGeometry(size.x + 0.0008, size.y + 0.0008, size.z + 0.0008);
      const edges = new THREE.EdgesGeometry(outlineGeo);
      const lineMat = new THREE.LineBasicMaterial({color:0xFFFFFF, linewidth:2, depthTest:true});
      const outline = new THREE.LineSegments(edges, lineMat);
      outline.position.copy(center);
      group.add(outline);
      group.traverse(c => {
        if (c.isMesh && c.material && c.material.emissive) {
          c.material.emissive = new THREE.Color(0xffffff);
          c.material.emissiveIntensity = 0.12;
        }
      });
    }

    scene.add(group);
    meshMap[box.id] = group;
  });
  // Prisen (via getBoxSupportType, som læser meshMap) må ALDRIG regnes ud
  // FØR meshMap er opdateret — ellers ser den boksene som "ikke tegnet
  // endnu" og gætter forkert (typisk: alt klassificeres som "wall", der
  // kræver vægbeslag, selv boksene der reelt er gulv- eller stabel-
  // stående). Derfor ligger opdateringen her, EFTER meshMap er frisk —
  // ikke i renderStack(), som ofte kaldes FØR denne funktion.
  renderSokkelPieces(); // afhænger også af frisk meshMap (positioner), samme grund som ovenfor
  updateTotal();
}

function refreshBox(id) {
  const box = DB.stack.find(b=>b.id===id);
  if (!box) return;
  const old = meshMap[id];
  const oldX = old ? old.position.x : (box.px||0);
  const oldY = old ? old.position.y : (box.py||floorRestY());
  if (old) scene.remove(old);

  const bt = DB.types.find(t=>t.id===box.typeId)||DB.types[0];
  const col= DB.colors.find(c=>c.id===box.colorId)||DB.colors[0]||FALLBACK_COLOR;
  const texUrl = col.tex || null;
  const drawerCol2 = DB.colors.find(c=>c.id===(box.drawerColorId||box.colorId))||col;
  const doorCol2   = DB.colors.find(c=>c.id===(box.doorColorId  ||box.colorId))||col;
  const {group, bw, bh, bd} = buildBox(bt, col.hex, texUrl, box.featureOn||false, drawerCol2.hex, drawerCol2.tex||null, doorCol2.hex, doorCol2.tex||null, box.doorHandleLeft||false);

  const zPos = WALL_Z + bd/2 + 0.0016;
  const yPos = Math.max(floorRestY(), oldY);
  group.position.set(oldX, yPos, zPos);
  box.px = oldX; box.py = yPos; box.pz = zPos;

  if (box.id===S.selId || S.multiSelIds.has(box.id)) {
    const savedPos = group.position.clone();
    group.position.set(0,0,0);
    group.updateMatrixWorld(true);
    const bbox = new THREE.Box3();
    bbox.makeEmpty();
    group.traverse(c => { if (c.isMesh && c.userData.isShell) bbox.expandByObject(c); });
    group.position.copy(savedPos);
    group.updateMatrixWorld(true);
    const size = new THREE.Vector3(); bbox.getSize(size);
    const center = new THREE.Vector3(); bbox.getCenter(center);
    // Tiny margin (~1mm total) just to avoid z-fighting — see rebuildScene.
    const outlineGeo = new THREE.BoxGeometry(size.x + 0.0008, size.y + 0.0008, size.z + 0.0008);
    const edges = new THREE.EdgesGeometry(outlineGeo);
    const lineMat = new THREE.LineBasicMaterial({color:0xFFFFFF, linewidth:2, depthTest:true});
    const outline = new THREE.LineSegments(edges, lineMat);
    outline.position.copy(center);
    group.add(outline);
    group.traverse(c => {
      if (c.isMesh && c.material && c.material.emissive) {
        c.material.emissive = new THREE.Color(0xffffff);
        c.material.emissiveIntensity = 0.12;
      }
    });
  }
  scene.add(group);
  meshMap[id] = group;
  // Se rebuildScene() for hvorfor — samme princip: meshMap skal være
  // frisk, FØR prisen (og dermed evt. vægbeslag/sokkel-behov) regnes ud.
  renderSokkelPieces(); // en enkelt boks kan have flyttet sig ELLER skiftet farve (soklen bruger første kubes farve)
  updateTotal();
}

// ═══════════════════════════════════════════
//  PANEL LOGIC
// ═══════════════════════════════════════════
function setMode(m) {
  S.mode = m;
  document.getElementById('modeAdd').style.display  = m==='add'  ? 'block':'none';
  document.getElementById('modeCust').style.display = m==='cust' ? 'block':'none';
  document.getElementById('btnAdd').classList.toggle('active',  m==='add');
  document.getElementById('btnCust').classList.toggle('active', m==='cust');

  // "Pandora Box"/"Byg din egen opbevaring"-titlen skjules i Tilpas —
  // giver plads til at boks-navnet ("Åben kube" osv.) rykker op på
  // samme plads i stedet, uden at vi behøver flytte selve elementet.
  const phTitle = document.getElementById('phTitle');
  const phSub = document.getElementById('phSub');
  if (phTitle) phTitle.style.display = m === 'cust' ? 'none' : '';
  if (phSub) phSub.style.display = m === 'cust' ? 'none' : '';

  // Selve top-navigationen (fanerne) vises kun i "Tilføj"-tilstand. I
  // "Tilpas" er "+ Tilføj kube"-knappen INDE i panelet (både i
  // custCtrls og i "ingen valgt"-visningen) den eneste vej tilbage — et
  // enklere, mere styret forløb: tilføj → tilpas → tilføj igen, i
  // stedet for faner man frit kan hoppe imellem.
  const navContainer = document.getElementById('btnAdd').parentElement;
  if (navContainer) {
    // Opsnapper den ÆGTE, oprindelige display-værdi første gang (i stedet
    // for at gætte fx 'flex') — sikrer at vi altid gendanner præcis den
    // rigtige CSS-værdi, uanset hvordan top-navigationen faktisk er bygget.
    if (!navContainer.dataset.origDisplay) {
      navContainer.dataset.origDisplay = getComputedStyle(navContainer).display || 'flex';
    }
    navContainer.style.display = m === 'cust' ? 'none' : navContainer.dataset.origDisplay;
  }

  if (m==='add')  renderTypeGrid();
  if (m==='cust') renderCustCtrls();
  openPanel();
}

function renderTypeGrid() {
  // Vis kortene med det samme (bt.price som hurtig placeholder), opdatér
  // så med den rigtige, kombinerede pris (basis + evt. tilkøb) når den er
  // hentet — undgår at typevælgeren opleves langsom/blokerende.
  document.getElementById('typeGrid').innerHTML = DB.types.map(bt=>`
    <div class="type-card ${S.selTypeId===bt.id?'selected':''}" onclick="pickType(${bt.id})">
      <div class="tc-icon">
        <svg viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
      </div>
      <div class="tc-name">${bt.name}</div>
      <div class="tc-dim">${bt.w}x${bt.h}x${bt.d}cm</div>
      <div class="tc-price" id="tcPrice${bt.id}">${fmtPrice(bt.price)}</div>
      <div class="tc-add">+ Tilføj</div>
    </div>`).join('');

  DB.types.forEach(async bt => {
    const combo = await getTypeDisplayPrice(bt, S.selColorId);
    const priceEl = document.getElementById(`tcPrice${bt.id}`);
    if (priceEl && combo != null) priceEl.textContent = fmtPrice(combo);
  });
}

function pickType(id) {
  S.selTypeId = id;
  addBox(id);
}

function addBox(typeId) {
  const id = DB.nextSID++;
  // Spread boxes out a bit (rough starting guess)
  const existingCount = DB.stack.length;
  const bt = DB.types.find(t=>t.id===typeId)||DB.types[0];
  const col = DB.colors.find(c=>c.id===S.selColorId)||DB.colors[0]||FALLBACK_COLOR;
  // Build a throwaway copy of the box purely to measure its real on-screen
  // size (never added to the scene) — the nominal bt.w/bt.h doesn't
  // reliably match what actually gets rendered, so we measure it directly
  // the same way the drag-collision logic does.
  const measure = buildBox(bt, col.hex, col.tex||null, false, col.hex, null, col.hex, null);
  const { w: bw, h: bh } = getVisualSize(measure.group);
  const spreadX = (existingCount - Math.floor(existingCount/2)) * (bw + 0.08) * (existingCount%2===0?1:-1);
  // Make sure the new box doesn't land on top of an existing one — the
  // spread guess above only accounts for the NEW box's own width, not the
  // sizes/positions of boxes already on the wall, so it could still overlap.
  const pos = resolveOverlap(id, bw, bh, spreadX, floorRestY());
  DB.stack.push({id, typeId, colorId:S.selColorId, drawerColorId:S.selColorId, textureId:null, featureOn:false, doorHandleLeft:false, px:pos.x, py:pos.y, pz:0});
  const prevSel = S.selId;
  S.selId = id;
  if (prevSel) refreshBox(prevSel); // remove highlight from previous
  renderTypeGrid();
  renderStack(); renderCustCtrls();
  refreshBox(id);
  document.getElementById('emptyState').style.display = 'none';
  center2DCamera();
  toast('Boks tilføjet ✓');
  // Skifter til Tilpas-tilstand på ALLE enheder nu, ikke kun mobil — det
  // nye, tilsigtede forløb er "tilføj kube → lander direkte i Tilpas for
  // netop den kube", uanset skærmstørrelse.
  setMode('cust');
  openPanel();
}

// ── CUST CONTROLS
// Opretter "+ Tilføj kube"-knappen INDE i Tilpas-panelet — kun én gang
// (ikke ved hver gentegning af panelet), lige under boks-info-headeren.
// Fører kunden tilbage til "Tilføj"-tilstand, så de kan tilføje endnu en
// kube — den tilsigtede, styrede vej frem og tilbage mellem de to.
function ensureBackToAddButton() {
  if (document.getElementById('backToAddBtn')) return;
  const metaEl = document.getElementById('biMeta');
  if (!metaEl) return;
  const header = metaEl.parentElement || metaEl;
  // Samme knap-stil (gylden gradient + hvid tekst) som "+ Tilføj kube" i
  // rum-visningen — hvid tekst på hvid baggrund var netop bugget, der
  // gjorde teksten usynlig her.
  header.insertAdjacentHTML('afterend', `
    <button id="backToAddBtn" type="button" onclick="setMode('add')" style="width:100%;margin:10px 0 4px;background:linear-gradient(135deg,#C4A87A,#a8895e);color:#fff;border:none;border-radius:10px;padding:12px;font-size:13px;font-weight:600;cursor:pointer;letter-spacing:0.3px;font-family:var(--font);">
      + Tilføj kube
    </button>`);
}

function renderCustCtrls() {
  const box = DB.stack.find(b=>b.id===S.selId);
  document.getElementById('noSel').style.display    = box?'none':'block';
  document.getElementById('custCtrls').style.display= box?'block':'none';
  if (!box) {
    // Ingen kube valgt — viser nu rum-indstillinger (væg/gulv/mål) her i
    // stedet for en tom "vælg en kube"-besked, siden "Rum" ikke længere
    // er sin egen fane.
    renderRoomPanel();
    return;
  }
  const bt = DB.types.find(t=>t.id===box.typeId)||{};
  document.getElementById('biName').textContent = bt.name||'Boks';
  document.getElementById('biMeta').textContent = `${bt.w}x${bt.h}x${bt.d}cm · Box #${box.id}`;
  ensureBackToAddButton();

  // Type-vælger — den oprindelige rækkeliste, men pakket ind i en
  // accordion: lukket som standard ("Ændre bokstype"), folder først
  // rækkerne ud, når man aktivt klikker på overskriften.
  document.getElementById('typeSwitch').innerHTML = `
    <div class="type-accordion-header" onclick="toggleTypeAccordion()" style="display:flex;align-items:center;justify-content:space-between;cursor:pointer;padding:4px 0;">
      <span style="font-size:11px;text-transform:uppercase;letter-spacing:.04em;color:#8a8378;">Ændre bokstype</span>
      <span id="typeAccordionChevron" style="font-size:11px;color:#8a8378;">▾</span>
    </div>
    <div id="typeAccordionBody" style="display:none;margin-top:8px;">
      ${DB.types.map(t=>`
        <div class="type-sw-row ${box.typeId===t.id?'active':''}" onclick="changeType(${t.id})">
          <div class="type-sw-dot">
            <svg viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/></svg>
          </div>
          <div class="type-sw-info">
            <div class="type-sw-name">${t.name}</div>
            <div class="type-sw-dim">${t.w}×${t.h}×${t.d} cm</div>
          </div>
          <div class="type-sw-check"></div>
        </div>`).join('')}
    </div>`;

  // Colors (with optional texture preview)
  document.getElementById('colorRow').innerHTML = DB.colors.map(c=>`
    <div class="csw ${box.colorId===c.id?'active':''}" 
         style="${c.tex ? `background:url('${c.tex}') center/cover` : `background:${c.hex}`}" 
         title="${c.name}" onclick="pickColor(${c.id})"></div>`).join('');

  // Drawer color (only for drawers type)
  const dcs = document.getElementById('drawerColorSect');
  if (bt.feature === 'drawers') {
    dcs.style.display = 'block';
    const dColorId = box.drawerColorId || box.colorId;
    // Viser KUN farver, der rent faktisk findes som en variant på selve
    // Skuffesæt-produktet — ellers kunne kunden vælge en farve, der ser
    // fin ud i 3D, men som stille forsvinder fra kurven ved "Læg i kurv".
    // Er dækningen ukendt (fx opslag fejlede), vises alle farver i stedet
    // for at skjule det hele på grund af en midlertidig netværksfejl.
    const drawerColors = DRAWER_COVERED_COLOR_IDS.size === 0
      ? DB.colors
      : DB.colors.filter(c => DRAWER_COVERED_COLOR_IDS.has(c.id));
    document.getElementById('drawerColorRow').innerHTML = drawerColors.map(c=>`
      <div class="csw ${dColorId===c.id?'active':''}" 
           style="${c.tex ? `background:url('${c.tex}') center/cover` : `background:${c.hex}`}" 
           title="${c.name}" onclick="pickDrawerColor(${c.id})"></div>`).join('');
  } else {
    dcs.style.display = 'none';
  }

  // Door color (only for door type)
  const doorcs = document.getElementById('doorColorSect');
  if (bt.feature === 'door') {
    doorcs.style.display = 'block';
    const doorColorId = box.doorColorId || box.colorId;
    // Samme dækningsfilter som skuffefarven ovenfor, bare mod Låge til
    // kube i stedet for Skuffesæt til kube.
    const doorColors = DOOR_COVERED_COLOR_IDS.size === 0
      ? DB.colors
      : DB.colors.filter(c => DOOR_COVERED_COLOR_IDS.has(c.id));
    document.getElementById('doorColorRow').innerHTML = doorColors.map(c=>`
      <div class="csw ${doorColorId===c.id?'active':''}" 
           style="${c.tex ? `background:url('${c.tex}') center/cover` : `background:${c.hex}`}" 
           title="${c.name}" onclick="pickDoorColor(${c.id})"></div>`).join('')
      + `<div style="flex-basis:100%;margin-top:14px;">
           <div class="sl" style="margin-bottom:6px;">Grebsvending</div>
           <div style="display:flex;gap:8px;">
             <div onclick="toggleDoorHandleSide(true)" style="flex:1;cursor:pointer;border:1.5px solid ${box.doorHandleLeft?'#1a1a1a':'#e0dbd5'};border-radius:8px;padding:8px 4px;text-align:center;background:#fdfcfb;">
               <svg width="52" height="40" viewBox="0 0 60 44" style="display:block;margin:0 auto;">
                 <rect x="4" y="4" width="52" height="36" rx="3" fill="none" stroke="#8a8378" stroke-width="2"/>
                 <circle cx="14" cy="22" r="3.5" fill="#2a2520"/>
               </svg>
               <div style="font-size:11px;color:#5a534a;margin-top:4px;">Venstre</div>
             </div>
             <div onclick="toggleDoorHandleSide(false)" style="flex:1;cursor:pointer;border:1.5px solid ${!box.doorHandleLeft?'#1a1a1a':'#e0dbd5'};border-radius:8px;padding:8px 4px;text-align:center;background:#fdfcfb;">
               <svg width="52" height="40" viewBox="0 0 60 44" style="display:block;margin:0 auto;">
                 <rect x="4" y="4" width="52" height="36" rx="3" fill="none" stroke="#8a8378" stroke-width="2"/>
                 <circle cx="46" cy="22" r="3.5" fill="#2a2520"/>
               </svg>
               <div style="font-size:11px;color:#5a534a;margin-top:4px;">Højre</div>
             </div>
           </div>
         </div>`;
  } else {
    doorcs.style.display = 'none';
  }

  // Feature toggle
  const fs = document.getElementById('featSect');
  if (bt.feature && bt.feature!=='open' && bt.feature!=='drawers' && bt.feature!=='shelf' && bt.feature!=='door') {
    fs.style.display='block';
    const labels={shelf:'Hylde',door:'Låge'};
    document.getElementById('featLabel').textContent=labels[bt.feature]||bt.feature;
    document.getElementById('featToggle').innerHTML=`
      <div class="toggle-row">
        <span class="tr-label">${labels[bt.feature]||bt.feature}</span>
        <span class="tr-price">inkl.</span>
        <label class="tog"><input type="checkbox" ${box.featureOn?'checked':''} onchange="toggleFeat(this.checked)"><span class="tog-sl"></span></label>
      </div>`;
  } else fs.style.display='none';
}

function pickDrawerColor(id) {
  const box=DB.stack.find(b=>b.id===S.selId);
  if(box){box.drawerColorId=id;renderCustCtrls();refreshBox(S.selId);}
}
function pickDoorColor(id) {
  const box=DB.stack.find(b=>b.id===S.selId);
  if(box){box.doorColorId=id;renderCustCtrls();refreshBox(S.selId);}
}
function toggleDoorHandleSide(isLeft) {
  const box=DB.stack.find(b=>b.id===S.selId);
  if(box){box.doorHandleLeft=isLeft;renderCustCtrls();refreshBox(S.selId);}
}
function pickColor(id) {
  S.selColorId=id;
  const box=DB.stack.find(b=>b.id===S.selId);
  if(box){box.colorId=id;renderCustCtrls();refreshBox(S.selId);renderStack();}
  if(S.mode==='add') renderTypeGrid();
}
function pickTex(id) {
  const box=DB.stack.find(b=>b.id===S.selId);
  if(box){box.textureId=id;renderCustCtrls();refreshBox(S.selId);}
}
function toggleFeat(v) {
  const box=DB.stack.find(b=>b.id===S.selId);
  if(box){box.featureOn=v;refreshBox(S.selId);}
}
function changeType(typeId) {
  const box=DB.stack.find(b=>b.id===S.selId);
  if(!box||box.typeId===typeId)return;
  box.typeId=typeId;
  box.featureOn=false; // reset feature when switching type
  renderCustCtrls(); refreshBox(S.selId); renderStack();
  toast('Boks-type ændret ✓');
}

// Åbner/lukker "Ændre bokstype"-accordionen. renderCustCtrls() bygger
// den lukket som standard hver gang panelet gentegnes — så den folder
// automatisk sig selv sammen igen, når man har valgt en ny type.
function toggleTypeAccordion() {
  const body = document.getElementById('typeAccordionBody');
  const chevron = document.getElementById('typeAccordionChevron');
  if (!body) return;
  const isOpen = body.style.display !== 'none';
  body.style.display = isOpen ? 'none' : 'block';
  if (chevron) chevron.textContent = isOpen ? '▾' : '▴';
}

// ── STACK
function toggleStack() {
  const body = document.getElementById('stackBody');
  const chevron = document.getElementById('stackChevron');
  const isOpen = body.classList.toggle('open');
  chevron.classList.toggle('open', isOpen);
}

function renderStack() {
  const el=document.getElementById('stackList');
  document.getElementById('stackCnt').textContent=`(${DB.stack.length})`;
  document.getElementById('saveBtn').disabled=DB.stack.length===0;
  // BEMÆRK: renderStack() regner IKKE længere prisen ud selv — det gjorde
  // den tidligere, men blev ofte kaldt FØR rebuildScene()/refreshBox()
  // havde nået at opdatere selve 3D-scenen, hvilket kunne give en forkert
  // (typisk for høj) pris et kort øjeblik, indtil noget andet rettede den
  // igen. Prisen opdateres nu udelukkende fra rebuildScene()/refreshBox()
  // selv, EFTER scenen reelt er frisk — se de to funktioner.
  if(!DB.stack.length){el.innerHTML='<div style="color:var(--text3);font-size:12px;text-align:center;padding:10px 0">Tom</div>';return;}
  el.innerHTML=DB.stack.map(box=>{
    const bt=DB.types.find(t=>t.id===box.typeId)||{};
    const col=DB.colors.find(c=>c.id===box.colorId)||{hex:'#ccc',name:'?'};
    const drawerCol=DB.colors.find(c=>c.id===(box.drawerColorId||box.colorId))||col;
    const doorCol=DB.colors.find(c=>c.id===(box.doorColorId||box.colorId))||col;
    const hasDrawer = bt.feature==='drawers';
    const hasDoor   = bt.feature==='door';
    let subLines = `<div class="si-m">Kube: ${col.name}</div>`;
    if (hasDrawer) subLines += `<div class="si-m">Skuffe: ${drawerCol.name}</div>`;
    if (hasDoor)   subLines += `<div class="si-m">Låge: ${doorCol.name}</div>`;
    return `<div class="si ${S.selId===box.id?'active':''}" onclick="selBox(${box.id})">
      <div class="si-dot" style="${col.tex?`background:url('${col.tex}') center/cover`:`background:${col.hex}`}" title="Kassens farve"></div>
      <div class="si-info">
        <div class="si-n">${bt.name||'Boks'}</div>
        ${subLines}
      </div>
      <div class="si-btns">
        <button class="sib" onclick="mvBox(${box.id},-1,event)" title="Venstre">←</button>
        <button class="sib" onclick="mvBox(${box.id},1,event)" title="Højre">→</button>
        <button class="sib del" onclick="rmBox(${box.id},event)">🗑</button>
      </div>
    </div>`;
  }).join('');
}

function selBox(id) {
  S.selId=(S.selId===id)?null:id;
  if(S.mode==='cust')renderCustCtrls();
  renderStack(); rebuildScene();
}
function mvBox(id,dir,e) {
  e.stopPropagation();
  const i=DB.stack.findIndex(b=>b.id===id);
  const j=i+dir;
  if(j<0||j>=DB.stack.length)return;
  // Swap visual positions too
  const px1=DB.stack[i].px, px2=DB.stack[j].px;
  DB.stack[i].px=px2; DB.stack[j].px=px1;
  [DB.stack[i],DB.stack[j]]=[DB.stack[j],DB.stack[i]];
  renderStack(); rebuildScene();
}
function rmBox(id,e) {
  e.stopPropagation();
  const g=meshMap[id]; if(g)scene.remove(g); delete meshMap[id];
  DB.stack=DB.stack.filter(b=>b.id!==id);
  if(S.selId===id)S.selId=null;
  document.getElementById('emptyState').style.display=DB.stack.length?'none':'flex';
  renderStack(); renderCustCtrls();
  // meshMap er allerede opdateret ovenfor (boksen fjernet direkte, ikke
  // via rebuildScene) — så prisen SKAL opdateres eksplicit her, siden
  // renderStack() ikke længere gør det selv.
  renderSokkelPieces(); // fjernet boks kan ændre gulv-rækkerne, soklen skal følge med
  updateTotal();
  center2DCamera();
  toast('Boks fjernet');
}

function fmtPrice(n){return n.toLocaleString('da-DK')+' kr.';}

// Simpel "generation"-guard: hvis updateTotal() kaldes igen før den
// forrige er færdig (fx hurtige farveskift), skal den ÆLDSTE beregning
// ikke få lov at overskrive den nyeste, bare fordi den tilfældigvis
// bliver hentet færdig sidst.
let _totalUpdateGen = 0;
async function updateTotal() {
  const myGen = ++_totalUpdateGen;
  let total = 0;
  const unpriced = new Set(); // til konsol-advarsel, ikke vist i UI
  const jobs = [];

  DB.stack.forEach(box => {
    const bt = DB.types.find(t => t.id === box.typeId) || { price: 0, code: '' };

    jobs.push(getKubeBasePrice(bt, box.colorId).then(p => {
      if (p != null) total += p; else unpriced.add(`${bt.code}_${box.colorId}`);
    }));

    // Skuffesæt håndteres IKKE her per kube — se groupDrawerColors()
    // nedenfor, da det sælges i sæt af 2 og rundes op per farve.
    if (bt.feature === 'door') {
      const colorKey = box.doorColorId || box.colorId;
      jobs.push(getFeatureAccessoryPrice('door', colorKey).then(p => {
        if (p != null) total += p; else unpriced.add('Låge til kube');
      }));
    }

    // Understøtning: ETHVERT kube skal have sit EGET vægbeslag, MEDMINDRE
    // den står direkte på en sokkel — se samme princip/kommentar i
    // buildShopifyCartItems() ovenfor. Tjekker mod ALT UNDTAGEN 'floor',
    // ikke kun 'wall', så stablede kuber ('stacked') også tælles korrekt
    // med i prisen.
    if (getBoxSupportType(box) !== 'floor') {
      jobs.push(getVaegbeslagPrice().then(p => {
        if (p != null) total += p; else unpriced.add('Vægbeslag');
      }));
    }
  });

  // Skuffesæt: sælges i sæt af 2, rundes op PER FARVE (bekræftet — kan
  // ikke deles mellem farver: 1 lilla + 1 gul = 2 fulde sæt, ikke ét).
  groupDrawerColors().forEach(({ colorId, setsNeeded }) => {
    jobs.push(getFeatureAccessoryPrice('drawers', colorId).then(p => {
      if (p != null) total += p * setsNeeded; else unpriced.add(`Skuffesæt til kube (farve ${colorId})`);
    }));
  });

  // Sokkel: prissættes PER RÆKKE (se buildShopifyCartItems for samme logik)
  groupFloorRows().forEach(row => {
    sokkelPiecesForRow(row.length).forEach(pieceSize => {
      jobs.push(getSokkelPiecePrice(pieceSize).then(p => {
        if (p != null) total += p; else unpriced.add(`Sokkel (${pieceSize} kube)`);
      }));
    });
  });

  await Promise.all(jobs);
  if (myGen !== _totalUpdateGen) return; // en nyere opdatering kører/er kørt — drop denne

  if (unpriced.size) {
    console.warn('Total mangler priser for:', [...unpriced].join(', '));
  }

  document.getElementById('totP').textContent = fmtPrice(total);
  scheduleAutoSave();
}

// ═══════════════════════════════════════════
//  GEM/GENSKAB — "Fortsæt hvor du slap" (24 timer)
// ═══════════════════════════════════════════
// Gemmer stille i baggrunden, hver gang opstillingen reelt er opdateret
// (se kaldet i updateTotal() ovenfor — samme pålidelige "state er nu
// frisk"-punkt, vi allerede har brugt til andre ting). Debounces et par
// sekunder, så det ikke skriver til localStorage konstant under et træk.
const SAVED_CONFIG_KEY = 'pandoraBoxSavedConfig';
const SAVED_CONFIG_MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24 timer
let _autoSaveTimer = null;

function scheduleAutoSave() {
  clearTimeout(_autoSaveTimer);
  _autoSaveTimer = setTimeout(saveConfigNow, 800);
}

function saveConfigNow() {
  try {
    if (!DB.stack.length) { localStorage.removeItem(SAVED_CONFIG_KEY); return; }
    const payload = {
      savedAt: Date.now(),
      cubes: DB.stack.map(b => ({
        typeId: b.typeId, colorId: b.colorId,
        drawerColorId: b.drawerColorId, doorColorId: b.doorColorId,
        doorHandleLeft: !!b.doorHandleLeft, px: b.px, py: b.py, featureOn: !!b.featureOn,
      })),
    };
    localStorage.setItem(SAVED_CONFIG_KEY, JSON.stringify(payload));
  } catch (err) {
    // fx private browsing/localStorage utilgængeligt — ikke kritisk, kunden
    // mister bare "fortsæt hvor du slap"-muligheden, resten virker fint.
    console.warn('Kunne ikke autogemme opstillingen lokalt:', err.message);
  }
}

// Kaldes ved opstart — viser et lille valg, HVIS der findes en gemt
// opstilling under 24 timer gammel. Returnerer true, hvis den viste
// prompten (så DOMContentLoaded ved, at "Kom godt i gang" ikke også skal
// popper op oveni — de to bør ikke konkurrere om skærmen).
function checkForSavedConfig() {
  let saved;
  try {
    const raw = localStorage.getItem(SAVED_CONFIG_KEY);
    if (!raw) return false;
    saved = JSON.parse(raw);
  } catch (err) {
    return false;
  }
  if (!saved || !saved.cubes || !saved.cubes.length) return false;
  if (Date.now() - (saved.savedAt || 0) > SAVED_CONFIG_MAX_AGE_MS) {
    localStorage.removeItem(SAVED_CONFIG_KEY);
    return false;
  }

  const modal = document.createElement('div');
  modal.style.cssText = 'position:absolute;inset:0;background:rgba(20,18,16,0.55);z-index:500;display:flex;align-items:center;justify-content:center;';
  modal.innerHTML = `
    <div style="background:#faf9f7;border-radius:14px;padding:24px;max-width:300px;width:90%;box-shadow:0 16px 48px rgba(0,0,0,0.2);text-align:center;">
      <div style="font-size:28px;margin-bottom:10px;">🔄</div>
      <div style="font-size:15px;font-weight:700;color:#2a2520;margin-bottom:6px;">Fortsæt hvor du slap?</div>
      <div style="font-size:12px;color:#8a8378;margin-bottom:16px;">Vi fandt en ufærdig opstilling fra dit sidste besøg.</div>
      <div style="display:flex;flex-direction:column;gap:8px;">
        <button id="continueSavedBtn" style="padding:10px;border-radius:8px;border:none;background:#1a1a1a;color:#fff;font-size:13px;font-weight:600;cursor:pointer;font-family:var(--font);">Fortsæt hvor jeg slap</button>
        <button id="startFreshBtn" style="padding:10px;border-radius:8px;border:1px solid #e0dbd5;background:#fff;font-size:13px;cursor:pointer;font-family:var(--font);">Start ny opstilling</button>
      </div>
    </div>`;
  const vpEl = document.getElementById('vp');
  (vpEl || document.body).appendChild(modal);

  document.getElementById('continueSavedBtn').onclick = () => {
    modal.remove();
    applyPresetObject({ cubes: saved.cubes });
    toast('Opstilling genskabt ✓');
  };
  document.getElementById('startFreshBtn').onclick = () => {
    modal.remove();
    localStorage.removeItem(SAVED_CONFIG_KEY);
  };
  return true;
}

// Globalt sokkel til/fra. Påvirker kun kuber der reelt står på gulvet
// (getBoxSupportType) — stablede kuber og væghængte kuber er upåvirkede.
// NB: Der er ikke en 3D-model for soklen endnu, så den vises ikke visuelt
// i scenen — toggle'en styrer prisen og hvad der ryger i Shopify-kurven.
// Separate 3D-objekter for sokkel-stykker — IKKE en del af nogen enkelt
// boks' gruppe, siden ét sokkel-stykke kan dække flere kuber. Ryddes og
// genopbygges fra bunden, hver gang layoutet ændrer sig.
let sokkelMeshes = [];
let _lastSokkelLogLine = null; // undgår at spamme konsollen med samme besked igen og igen under et træk

function renderSokkelPieces() {
  sokkelMeshes.forEach(m => scene.remove(m));
  sokkelMeshes = [];

  if (!S.sokkelOn) return;

  const rows = groupFloorRows();
  const placedCounts = {}; // { '1 kube': 2, '3 kuber': 1, ... }
  const missingSizes = new Set();

  rows.forEach(row => {
    const pieces = sokkelPiecesForRow(row.length);
    let idx = 0;
    pieces.forEach(pieceSize => {
      const groupBoxes = row.slice(idx, idx + pieceSize);
      idx += pieceSize;

      const key = 'sokkel_' + pieceSize;
      const template = BUILTIN_MODEL_CACHE[key];
      // Denne størrelse er ikke uploadet endnu — springes visuelt over.
      // Prisen/kurven er upåvirket, det er kun selve 3D-visningen her.
      if (!template) { missingSizes.add(pieceSize); return; }

      const firstItem = groupBoxes[0];
      const lastItem = groupBoxes[groupBoxes.length - 1];
      const centerX = (firstItem.x + lastItem.x) / 2;
      const firstGroup = meshMap[firstItem.box.id];
      const zPos = firstGroup ? firstGroup.position.z : 0;

      const clone = cloneModel(template);
      const rawBox = new THREE.Box3().setFromObject(clone);
      const rawCenter = new THREE.Vector3(); rawBox.getCenter(rawCenter);
      const off = BUILTIN_MODEL_OFFSETS[key] || { x: 0, y: 0, z: 0 };

      clone.scale.set(MODEL_UNIT_SCALE, MODEL_UNIT_SCALE, MODEL_UNIT_SCALE);
      // Soklens FØDDER skal ramme den ÆGTE gulvflade (y=0) — IKKE en fast
      // antaget værdi (BASEBOARD_H), som ikke matchede jeres models
      // faktiske højde og fik fødderne til at synke under gulvet.
      const bottomWorld = rawBox.min.y * MODEL_UNIT_SCALE;
      const yOffset = -bottomWorld;
      // RETTET: Z manglede den samme centrerings-korrektion som X allerede
      // fik (-rawCenter.z * MODEL_UNIT_SCALE) — uden den blev soklens
      // egen, ofte ikke-centrerede Z-oprindelse aldrig kompenseret for,
      // hvilket kunne placere den et helt forkert sted i dybden.
      clone.position.set(
        centerX - rawCenter.x * MODEL_UNIT_SCALE + off.x,
        yOffset + off.y,
        zPos - rawCenter.z * MODEL_UNIT_SCALE + off.z
      );

      // Soklen bruger sine EGNE materialer, som de allerede er bagt ind i
      // .glb-filen (fx pladen og stilleben har hver deres rigtige,
      // faste farve) — INGEN overskrivning med kubens farve, i
      // modsætning til skal/skuffe/hylde/låge. Sætter kun skygge-
      // flagene, rører ikke selve materialet.
      clone.traverse(c => {
        if (!c.isMesh) return;
        c.castShadow = true; c.receiveShadow = true;
        // Tvinger begge sider til at vise sig, uanset normal-retning —
        // en flad plade med omvendte normaler (almindeligt ved visse
        // eksport-indstillinger) kan ellers blive helt usynlig fra den
        // "forkerte" side, uden at kaste nogen fejl overhovedet.
        if (c.material) c.material.side = THREE.DoubleSide;
      });

      scene.add(clone);
      sokkelMeshes.push(clone);
      const label = pieceSize === 1 ? '1 kube' : `${pieceSize} kuber`;
      placedCounts[label] = (placedCounts[label] || 0) + 1;
    });
  });

  // Én kort, samlet linje — men KUN hvis indholdet reelt har ændret sig
  // siden sidst (fx under et træk, hvor denne funktion kan kaldes mange
  // gange i sekundet uden at sokkel-opsætningen faktisk skifter).
  if (Object.keys(placedCounts).length || missingSizes.size) {
    const placedStr = Object.entries(placedCounts)
      .map(([label, count]) => count > 1 ? `${count}× sokkel (${label})` : `sokkel (${label})`)
      .join(', ');
    const missingStr = missingSizes.size
      ? ` — mangler model til: ${[...missingSizes].sort().map(n => n === 1 ? '1 kube' : `${n} kuber`).join(', ')}`
      : '';
    const line = `${placedStr || 'intet vist'}${missingStr}`;
    if (line !== _lastSokkelLogLine) {
      console.info(`[sokkel] ${line}`);
      _lastSokkelLogLine = line;
    }
  }
}

function toggleSokkel() {
  S.sokkelOn = !S.sokkelOn;
  document.getElementById('sokkelToggle').style.background = S.sokkelOn ? '#1a1a1a' : '#d8d2c8';
  document.getElementById('sokkelKnob').style.transform = S.sokkelOn ? 'translateX(18px)' : 'translateX(0)';
  renderSokkelPieces();
  updateTotal();
}

function doSave(){
  saveConfigNow();
  toast('Konfiguration gemt ✓ — du kan fortsætte her i op til 24 timer');
}

// ═══════════════════════════════════════════
//  VIEW TOGGLE
// ═══════════════════════════════════════════
function center2DCamera() {
  if (!is2D || !DB.stack.length) return;
  let minX=Infinity, maxX=-Infinity, minY=Infinity, maxY=-Infinity;
  DB.stack.forEach(box => {
    const g = meshMap[box.id]; if (!g) return;
    const bt = DB.types.find(t=>t.id===box.typeId)||DB.types[0];
    const bw = bt.w * SCL, bh = bt.h * SCL;
    minX = Math.min(minX, g.position.x - bw/2);
    maxX = Math.max(maxX, g.position.x + bw/2);
    minY = Math.min(minY, g.position.y);
    maxY = Math.max(maxY, g.position.y + bh);
  });
  if (minX === Infinity) return;
  orbit.targetPanX = (minX + maxX) / 2;
  orbit.targetPanY = (minY + maxY) / 2;
}

function setView(v) {
  document.getElementById('btn3d').classList.toggle('active',v==='3d');
  document.getElementById('btn2d').classList.toggle('active',v==='2d');
  is2D = (v === '2d');
  if (v==='2d') {
    orbit.targetPhi   = Math.PI / 2;
    orbit.targetTheta = 0;
    orbit.targetRadius = 4.48;
    orbit.targetPanX  = 0;
    orbit.targetPanY  = 3;
    center2DCamera();
  } else {
    orbit.targetPhi   = 1.25;
    orbit.targetTheta = -0.2;
    orbit.targetRadius = 12;
    orbit.targetPanY  = 0.5;
  }
}

function clearAll() {
  // Custom confirm since browser confirm() may be blocked in iframes
  const modal = document.createElement('div');
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.45);z-index:9999;display:flex;align-items:center;justify-content:center;';
  modal.innerHTML = `
    <div style="background:#faf9f7;border-radius:14px;padding:24px;max-width:320px;width:90%;box-shadow:0 16px 48px rgba(0,0,0,0.2);text-align:center;">
      <div style="font-size:28px;margin-bottom:12px;">🗑</div>
      <div style="font-size:15px;font-weight:700;color:#2a2520;margin-bottom:8px;">Ryd alt?</div>
      <div style="font-size:13px;color:#888;margin-bottom:20px;">Alle kuber fjernes fra din opstilling.</div>
      <div style="display:flex;gap:8px;">
        <button id="clearCancel" style="flex:1;padding:10px;border-radius:8px;border:1px solid #e0dbd5;background:#fff;font-size:13px;cursor:pointer;font-family:var(--font);">Annuller</button>
        <button id="clearConfirm" style="flex:1;padding:10px;border-radius:8px;border:none;background:#c0392b;color:#fff;font-size:13px;font-weight:600;cursor:pointer;font-family:var(--font);">Ryd alt</button>
      </div>
    </div>`;
  document.body.appendChild(modal);
  document.getElementById('clearCancel').onclick = () => document.body.removeChild(modal);
  document.getElementById('clearConfirm').onclick = () => {
    document.body.removeChild(modal);
    DB.stack = [];
    S.selId = null;
    renderStack();
    renderCustCtrls();
    rebuildScene();
    toast('Alt ryddet');
  };
}
// ── TOAST
let _tt;
function toast(msg){const e=document.getElementById('toast');e.textContent=msg;e.classList.add('show');clearTimeout(_tt);_tt=setTimeout(()=>e.classList.remove('show'),2400);}

function openPanel(){
  if(isMobile()) document.querySelector('.panel').classList.add('open');
}
function togglePanel(){
  if(!isMobile())return;
  document.querySelector('.panel').classList.toggle('open');
}

// ── MOBILE PANEL
function isMobile(){return window.innerWidth<=700;}
function setupMobilePanel(){
  const panel = document.querySelector('.panel');
  if(!panel)return;

  // Tap the drag handle (::before) area = top 28px of panel
  panel.addEventListener('click', e=>{
    if(!isMobile())return;
    const rect = panel.getBoundingClientRect();
    if(e.clientY - rect.top < 32) togglePanel();
  });

  // Swipe down to close, swipe up to open
  let startY=0, startOpen=false;
  panel.addEventListener('touchstart', e=>{
    startY = e.touches[0].clientY;
    startOpen = panel.classList.contains('open');
  },{passive:true});
  panel.addEventListener('touchend', e=>{
    const dy = e.changedTouches[0].clientY - startY;
    if(dy > 60 && startOpen) panel.classList.remove('open');
    if(dy < -60 && !startOpen) panel.classList.add('open');
  },{passive:true});
}

// ── INIT
window.addEventListener('DOMContentLoaded', async ()=>{
  // FIX: .topbar (3D/2D-knapperne m.m.) er en SIBLING af .app i selve
  // temaets markup, ikke nestet inde i #vp som tiltænkt — så #vp's
  // "position:relative" kan aldrig scope den, uanset CSS. Flytter den
  // ind i #vp som første barn her, så position:absolute rent faktisk
  // positionerer relativt til selve 3D-boksen, ikke hele siden. Retter
  // det i selve HTML'en (i .liquid-filen) er den "rigtige" løsning på
  // sigt, men dette virker uden at skulle røre temaets markup.
  const vpEl = document.getElementById('vp');
  const topbarEl = document.querySelector('.topbar');
  if (vpEl && topbarEl && topbarEl.parentElement !== vpEl) {
    vpEl.prepend(topbarEl);
  }

  // Samme fix for #presetModal ("Kom godt i gang") — den er OGSÅ en
  // sibling af .app i markuppet, og har desuden position:fixed sat
  // (altid relativt til hele browservinduet, uanset ancestor), hvilket
  // tilsammen gjorde at den dækkede hele siden i stedet for kun selve
  // konfigurator-boksen. Flytter den ind i #vp OG skifter den til
  // position:absolute, så den bliver scopet til #vp i stedet.
  const presetModalEl = document.getElementById('presetModal');
  if (vpEl && presetModalEl) {
    presetModalEl.style.position = 'absolute';
    if (presetModalEl.parentElement !== vpEl) vpEl.appendChild(presetModalEl);
  }

  initThree();
  await loadRemoteConfig();
  await computeAccessoryColorCoverage();
  await preloadCustomTypeModels();
  await preloadBuiltinModels();
  // Nu hvor de rigtige admin-farver er hentet, sæt standardvalget til den
  // FØRSTE af dem, i stedet for et hardcodet id, der ikke længere findes.
  S.selColorId = (DB.colors[0] || FALLBACK_COLOR).id;
  setFloor('wood_oak');
  setMode('add'); // sikrer Rum-fanen skjules og topnavigationen sættes korrekt op fra start
  renderStack();
  updateTotal(); // sikrer korrekt startpris (0 kr.) vist med det samme ved tomt opstart
  setupMobilePanel();
  // Adjust toast position on mobile so it clears the panel
  if(isMobile()){
    document.getElementById('toast').style.bottom='80px';
  }
  // "Fortsæt hvor du slap" har forrang — vis kun "Kom godt i gang", hvis
  // der IKKE var en gemt opstilling at genskabe (de to bør ikke konkurrere
  // om skærmen ved opstart).
  setTimeout(() => {
    const hadSavedConfig = checkForSavedConfig();
    if (!hadSavedConfig) openPresetModal();
  }, 300);
});

window.addEventListener('resize',()=>{
  resizeThree();
  if(!isMobile()) document.querySelector('.panel').classList.remove('open');
});
function renderRoomPanel() {
  // Wall colour swatches
  document.getElementById('wallColorRow').innerHTML = WALL_PRESETS.map(p=>`
    <div class="wall-preset ${RS.wallHex===p.hex?'active':''}" 
         style="background:${p.hex}" title="${p.name}"
         onclick="setWallColor('${p.hex}')"></div>`).join('');

  // Floor options
  document.getElementById('floorGrid').innerHTML = FLOOR_OPTIONS.map(f=>`
    <div class="floor-opt ${RS.floorId===f.id?'active':''}" onclick="setFloor('${f.id}')">
      <div class="floor-thumb" style="${floorThumbStyle(f)}"></div>
      <div class="floor-lbl">${f.label}</div>
    </div>`).join('');

  document.getElementById('showDims').checked = RS.showDims;
}

function floorThumbStyle(f) {
  if (f.pattern === 'image') {
    return `background:url('${f.tex}') center/cover`;
  }
  if (f.pattern === 'oak' || f.pattern === 'walnut') {
    const c = f.color, c2 = shiftHex(f.color, -15);
    return `background: repeating-linear-gradient(90deg, ${c} 0px, ${c} 18px, ${c2} 18px, ${c2} 20px)`;
  }
  if (f.pattern === 'herring') {
    const c = f.color, c2 = shiftHex(f.color, -15);
    return `background: repeating-linear-gradient(45deg, ${c} 0px, ${c} 10px, ${c2} 10px, ${c2} 20px)`;
  }
  if (f.pattern === 'tile_white' || f.pattern === 'tile_dark') {
    const c = f.color, c2 = shiftHex(f.color, f.pattern==='tile_white'?-20:15);
    return `background: repeating-conic-gradient(${c} 0% 25%, ${c2} 0% 50%) 0 0 / 20px 20px`;
  }
  return `background:${f.color}`;
}

function shiftHex(hex, amount) {
  const n = parseInt(hex.slice(1), 16);
  const r = Math.max(0, Math.min(255, ((n>>16)&255) + amount));
  const g = Math.max(0, Math.min(255, ((n>>8)&255)  + amount));
  const b = Math.max(0, Math.min(255, (n&255)        + amount));
  return '#'+(r<<16|g<<8|b).toString(16).padStart(6,'0');
}

function setWallColor(hex) {
  RS.wallHex = hex;
  // Update Three.js wall
  wallMesh.material.color.set(hex);
  // Also tint clear color slightly
  renderer.setClearColor(new THREE.Color(hex).lerp(new THREE.Color(0x000000), 0.08), 1);
  renderRoomPanel();
}

function setFloor(id) {
  RS.floorId = id;
  const f = FLOOR_OPTIONS.find(x=>x.id===id);
  if (!f) return;

  if (f.pattern === 'image') {
    const t = new THREE.TextureLoader().load(f.tex);
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    t.encoding = THREE.sRGBEncoding;
    t.repeat.set(15, 15);
    floorMesh.material.map = t;
    floorMesh.material.color.set(0xffffff);
    floorMesh.material.needsUpdate = true;
  } else if (f.pattern === 'oak' || f.pattern === 'walnut') {
    applyFloorStripes(f.color, shiftHex(f.color, -15), 'vertical');
  } else if (f.pattern === 'herring') {
    applyFloorStripes(f.color, shiftHex(f.color, -15), 'diagonal');
  } else if (f.pattern === 'tile_white' || f.pattern === 'tile_dark') {
    applyFloorTiles(f.color, shiftHex(f.color, f.pattern==='tile_white'?-20:15));
  } else {
    floorMesh.material.map = null;
    floorMesh.material.color.set(f.color);
    floorMesh.material.needsUpdate = true;
  }
  renderRoomPanel();
}

function makeCanvasTex(draw, size=512) {
  const cv = document.createElement('canvas');
  cv.width = cv.height = size;
  draw(cv.getContext('2d'), size);
  const t = new THREE.CanvasTexture(cv);
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  t.repeat.set(1.5, 1.5);
  return t;
}

function applyFloorStripes(c1, c2, dir) {
  const t = makeCanvasTex((ctx, s)=>{
    ctx.fillStyle = c1; ctx.fillRect(0,0,s,s);
    ctx.fillStyle = c2;
    const bw = s/8;
    for(let i=0;i<8;i+=2) {
      if(dir==='diagonal') {
        ctx.save(); ctx.translate(i*bw+bw/2, s/2); ctx.rotate(Math.PI/4);
        ctx.fillRect(-bw/2,-s,bw,s*3); ctx.restore();
      } else {
        ctx.fillRect(i*bw, 0, bw, s);
      }
    }
    // subtle grain lines
    ctx.strokeStyle = 'rgba(0,0,0,0.07)'; ctx.lineWidth=1;
    for(let i=0;i<8;i++){ctx.beginPath();ctx.moveTo(i*bw,0);ctx.lineTo(i*bw,s);ctx.stroke();}
  });
  floorMesh.material.map = t;
  floorMesh.material.color.set(0xffffff);
  floorMesh.material.needsUpdate = true;
}

function applyFloorTiles(c1, c2) {
  const t = makeCanvasTex((ctx, s)=>{
    const ts=s/4;
    for(let r=0;r<4;r++) for(let cc=0;cc<4;cc++) {
      ctx.fillStyle=(r+cc)%2===0?c1:c2;
      ctx.fillRect(cc*ts,r*ts,ts,ts);
      ctx.strokeStyle='rgba(200,200,200,0.4)'; ctx.lineWidth=2;
      ctx.strokeRect(cc*ts+1,r*ts+1,ts-2,ts-2);
    }
  });
  floorMesh.material.map = t;
  floorMesh.material.color.set(0xffffff);
  floorMesh.material.needsUpdate = true;
}

// ═══════════════════════════════════════════
//  DIMENSIONS OVERLAY
// ═══════════════════════════════════════════
function toggleDimensions(on) {
  RS.showDims = on;
  document.getElementById('btnDims').classList.toggle('active', on);
  // Sync checkbox in room panel if visible
  const cb = document.getElementById('showDims');
  if (cb) cb.checked = on;
  updateDimOverlay();
}

function worldToScreen(pos) {
  const v = pos.clone().project(camera);
  const vp = document.getElementById('vp');
  return {
    x: (v.x * 0.5 + 0.5) * vp.clientWidth,
    y: (-v.y * 0.5 + 0.5) * vp.clientHeight
  };
}

// Rydder helt små (sub-millimeter til ~3mm) uundgåelige unøjagtigheder fra
// snap-/kollisions-logikken op i den VISTE måletekst — de er usynlige i
// selve 3D-visningen og påvirker intet funktionelt (pris, kurv osv.), men
// ser akavet ud som fx "72.1 cm" i stedet for det tilsigtede "72 cm".
// Rører IKKE ved selve positionerings-logikken, kun label-teksten.
function roundDimForDisplay(cm) {
  const rounded = Math.round(cm);
  return Math.abs(cm - rounded) < 0.3 ? String(rounded) : cm.toFixed(1);
}

function updateDimOverlay() {
  const ov = document.getElementById('dimOverlay');
  ov.innerHTML = '';
  if (!RS.showDims) return;

  // Find rightmost box — height label shown only once on it
  let rightmostBox = null, rightmostX = -Infinity;
  DB.stack.forEach(box => {
    const g = meshMap[box.id]; if (!g) return;
    const bt = DB.types.find(t=>t.id===box.typeId)||DB.types[0];
    const rx = g.position.x + bt.w*SCL/2;
    if (rx > rightmostX) { rightmostX = rx; rightmostBox = box; }
  });

  DB.stack.forEach(box => {
    const g = meshMap[box.id]; if (!g) return;
    const bt = DB.types.find(t=>t.id===box.typeId)||DB.types[0];
    const bw=bt.w*SCL, bh=bt.h*SCL, bd=bt.d*SCL;
    const cx=g.position.x, cy=g.position.y, cz=g.position.z;

    // Width — only show per box if there's just 1 box
    if (DB.stack.length === 1) {
      const wLabel = `← ${bt.w} cm →`;
      addDimLabel(ov, wLabel, worldToScreen(new THREE.Vector3(cx, cy+bh+0.05, cz+bd/2)));
    }

    // Height — only on rightmost box, right side
    if (box === rightmostBox) {
      let minY=Infinity, maxY=-Infinity;
      DB.stack.forEach(b => {
        const bg = meshMap[b.id]; if (!bg) return;
        const bbt = DB.types.find(t=>t.id===b.typeId)||DB.types[0];
        minY = Math.min(minY, bg.position.y);
        maxY = Math.max(maxY, bg.position.y + bbt.h*SCL);
      });
      const totalH = roundDimForDisplay((maxY - minY) / SCL);
      const label = DB.stack.length > 1 ? `↑ ${totalH} cm ↓` : `↑ ${bt.h} cm ↓`;
      addDimLabel(ov, label, worldToScreen(new THREE.Vector3(cx+bw/2+0.07, cy+bh/2, cz+bd/2)));
    }

    // Depth — only on rightmost box, on top face
    if (box === rightmostBox) {
      addDimLabel(ov, `${bt.d} cm`, worldToScreen(new THREE.Vector3(cx+bw/2-0.04, cy+bh+0.02, cz)), false, true);
    }
  });

  // Total width spanning all boxes (>1)
  if (DB.stack.length > 1) {
    let minX=Infinity, maxX=-Infinity, maxY=-Infinity, sumZ=0;
    DB.stack.forEach(box=>{
      const g=meshMap[box.id]; if(!g) return;
      const bt=DB.types.find(t=>t.id===box.typeId)||DB.types[0];
      minX=Math.min(minX, g.position.x - bt.w*SCL/2);
      maxX=Math.max(maxX, g.position.x + bt.w*SCL/2);
      maxY=Math.max(maxY, g.position.y + bt.h*SCL);
      sumZ+=g.position.z;
    });
    // Divide by SCL to convert Three.js units → cm
    const totalW = roundDimForDisplay((maxX - minX) / SCL);
    const avgZ = sumZ / DB.stack.length;
    addDimLabel(ov, `← ${totalW} cm →`,
      worldToScreen(new THREE.Vector3((minX+maxX)/2, maxY+0.12, avgZ+0.18)), true);
  }
}

function addDimLabel(parent, text, screen, bold=false, small=false) {
  const d = document.createElement('div');
  d.className = 'dim-label';
  d.textContent = text;
  d.style.left = screen.x + 'px';
  d.style.top  = screen.y + 'px';
  d.style.transform = 'translate(-50%,-50%)';
  if (bold)  d.style.fontWeight = '700';
  if (small) d.style.opacity = '0.7';
  parent.appendChild(d);
}

// Pandora Box — OPSTILLINGER (PRESETS)
// Opstillinger hentes nu udelukkende fra admin-appen (REMOTE_PRESETS,
// hentet i loadRemoteConfig()) — ingen hardcodede demo-opstillinger
// længere. Byg/redigér opstillinger i admin-appens "Opstillinger"-fane.

// Anvender en opstilling på scenen — deler samme logik uanset om den
// kommer fra admin-appen (cubes) eller en ældre, manuelt indsat JSON
// (boxes, fra det interne Ctrl+Shift+A-admin-panel).
function applyPresetObject(preset) {
  DB.stack = [];
  // Findes farve-id'et ikke (fx en gammel opstilling fra før admin-appen),
  // brug den aktuelt valgte/standard farve i stedet for at vise en
  // tilfældig/forkert farve.
  const safeColorId = (id) => {
    if (DB.colors.some(c => c.id === id)) return id;
    // Logges tydeligt i konsollen, så vi kan se PRÆCIS hvilket id der
    // ikke matcher noget — i stedet for bare at falde tilbage stille.
    console.warn(`Opstilling: farve-id "${id}" (type ${typeof id}) findes ikke i DB.colors — falder tilbage til standardfarve. Kendte id'er:`, DB.colors.map(c => c.id));
    return S.selColorId;
  };
  const items = preset.cubes || preset.boxes || [];
  items.forEach((b) => {
    DB.stack.push({
      id: DB.nextId++,
      typeId: b.typeId,
      colorId: safeColorId(b.colorId),
      drawerColorId: safeColorId(b.drawerColorId != null ? b.drawerColorId : b.colorId),
      doorColorId: safeColorId(b.doorColorId != null ? b.doorColorId : b.colorId),
      textureId: null,
      featureOn: !!b.featureOn,
      doorHandleLeft: !!b.doorHandleLeft,
      px: b.px,
      py: b.py,
      pz: 0,
      _noSnap: true
    });
  });
  renderStack();
  renderCustCtrls();
  rebuildScene();
}

function loadPreset(id) {
  const preset = REMOTE_PRESETS.find(p => p.id === id);
  if (!preset) return;
  applyPresetObject(preset);
  closePresetModal();
  toast(`"${preset.name}" opstilling loaded!`);
}

let presetModalPage = 0;
const PRESETS_PER_PAGE = 4; // 2×2 gitter per side

function openPresetModal() {
  presetModalPage = 0;
  renderPresetModalPage();
  document.getElementById('presetModal').style.display='flex';
}

function renderPresetModalPage() {
  const grid = document.getElementById('presetGrid');
  if (!REMOTE_PRESETS.length) {
    grid.style.display = 'block';
    grid.innerHTML = `<p style="font-size:13px;color:#8a8378;text-align:center;padding:24px 8px;">Ingen opstillinger tilgængelige endnu.</p>`;
    return;
  }

  const totalPages = Math.ceil(REMOTE_PRESETS.length / PRESETS_PER_PAGE);
  presetModalPage = Math.max(0, Math.min(presetModalPage, totalPages - 1));
  const start = presetModalPage * PRESETS_PER_PAGE;
  const pagePresets = REMOTE_PRESETS.slice(start, start + PRESETS_PER_PAGE);

  const cardsHtml = pagePresets.map(p => `
    <div onclick="loadPreset(${p.id})" style="background:#fff;border:1.5px solid #e8e4dc;border-radius:12px;padding:16px;cursor:pointer;transition:all 0.15s;overflow:hidden;min-height:190px;box-sizing:border-box;"
         onmouseover="this.style.borderColor='#C4A87A';this.style.background='#fdf9f4'"
         onmouseout="this.style.borderColor='#e8e4dc';this.style.background='#fff'">
      ${presetCoverHtml(p)}
      <div style="font-size:13px;font-weight:600;color:#2a2520;margin-top:10px;">${escapeHtml(p.name)}</div>
      <div style="font-size:11px;color:#999;margin-top:2px;">${(p.cubes || []).length} kube(r)</div>
    </div>`).join('');

  // Polstrer med USYNLIGE pladsholder-kort, så gitteret altid fylder
  // præcis 2×2 — forhindrer at containeren (og dermed pilenes lodrette
  // centrering) bliver lavere på en side med færre end 4 opstillinger.
  // VIGTIGT: en tom div uden højde/indhold fylder reelt intet, selv med
  // visibility:hidden — den skal have samme min-height som de rigtige
  // kort for faktisk at optage pladsen.
  const ghostCount = PRESETS_PER_PAGE - pagePresets.length;
  const ghostsHtml = Array(ghostCount).fill('<div style="visibility:hidden;min-height:190px;" aria-hidden="true"></div>').join('');

  const showArrows = totalPages > 1;
  const prevDisabled = presetModalPage === 0;
  const nextDisabled = presetModalPage >= totalPages - 1;
  // Absolut positioneret og lodret centreret via top:50%/translateY —
  // langt mere robust end at stole på flex-centrering, som ikke gav en
  // pålidelig centrering her.
  const arrowStyle = (disabled) => `position:absolute;top:50%;transform:translateY(-50%);width:32px;height:32px;border-radius:50%;border:1px solid #e8e4dc;background:#fff;font-size:16px;color:#2a2520;cursor:${disabled?'default':'pointer'};opacity:${disabled?0.3:1};z-index:2;`;

  grid.style.display = 'block';
  grid.innerHTML = `
    <div style="position:relative;${showArrows ? 'padding:0 40px;' : ''}">
      ${showArrows ? `<button onclick="changePresetPage(-1)" ${prevDisabled?'disabled':''} style="${arrowStyle(prevDisabled)}left:0;">‹</button>` : ''}
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">${cardsHtml}${ghostsHtml}</div>
      ${showArrows ? `<button onclick="changePresetPage(1)" ${nextDisabled?'disabled':''} style="${arrowStyle(nextDisabled)}right:0;">›</button>` : ''}
    </div>
    ${showArrows ? `<div style="text-align:center;margin-top:12px;font-size:11px;color:#999;">${presetModalPage + 1} / ${totalPages}</div>` : ''}
  `;
}

function changePresetPage(delta) {
  presetModalPage += delta;
  renderPresetModalPage();
}

function closePresetModal() {
  document.getElementById('presetModal').style.display='none';
}

// Opstillingens forsidebillede — bruger admins uploadede miljøbillede,
// hvis der er ét. Ellers en simpel, forenklet gitter-forhåndsvisning
// bygget ud fra kubernes px/py (samme princip som før, bare uden krav om
// at de sidder på et perfekt gitter).
function presetCoverHtml(p) {
  if (p.image) {
    return `<div style="width:100%;height:110px;border-radius:8px;overflow:hidden;"><img src="${escapeHtml(p.image)}" style="width:100%;height:100%;object-fit:cover;" alt=""></div>`;
  }
  return `<div style="display:flex;flex-direction:column;gap:3px;">${renderPresetGrid(p)}</div>`;
}

function renderPresetGrid(p) {
  const typeIcons = {1:'', 2:'─', 3:'☰', 4:'▪'};
  const boxes = p.cubes || p.boxes || [];
  const pys = [...new Set(boxes.map(b=>Math.round(b.py*1000)))].sort((a,b)=>b-a); // top row first
  const pxs = [...new Set(boxes.map(b=>Math.round(b.px*1000)))].sort((a,b)=>a-b); // left to right
  const rows = pys.map(py => pxs.map(px => {
    const b = boxes.find(bb => Math.round(bb.py*1000)===py && Math.round(bb.px*1000)===px);
    return b ? b.typeId : null;
  }));
  return rows.map(row => `
    <div style="display:flex;gap:3px;">
      ${row.map(t => t
        ? `<div style="width:28px;height:28px;background:#C4A87A;border-radius:3px;border:1px solid rgba(0,0,0,0.15);display:flex;align-items:center;justify-content:center;font-size:9px;color:rgba(0,0,0,0.4);">${typeIcons[t]||''}</div>`
        : `<div style="width:28px;height:28px;"></div>`
      ).join('')}
    </div>`).join('');
}